import React, { useState, useEffect } from 'react';
import './Publication.css';

const publicationsData = {
  "2026":[
    {
      id: 185,
      authors: "Manikumar Kodieswaran, Debajyoti Pal, Durba Banerjee, Chevella Maheshwari, Rajat Dadheech, Samit Kumar Nandi, Sudip Mukherjee, Biman B Mandal",
      title: "On-demand biocatalytic dual oxygen spray reprograms the hypoxia-ferroptosis axis to accelerate chronic wound healing",
      journal: "Biomaterials",
      year: "2026",
      impactFactor: "13.6",
      doi: "https://doi.org/10.1016/j.biomaterials.2026.124702",
      type: "Research Article"
    },
    {
      id: 185,
      authors: "Ritvika Kushwaha, Nisha Job, Sayanti Shome, Malay Kumar Baroi, Verbi P. Bhagabati, Priyam Das, Rakesh Routh, Biman B. Mandal, Kalishankar Bhattacharya, Debapratim Das",
      title: "Stabilisation of Liquid Metal With a Short Peptide to Prepare Adhesive Piezoresistive Stretchable Hydrogel for Advanced Applications",
      journal: "Small",
      year: "2026",
      impactFactor: "11.8",
      doi: "https://doi.org/10.1002/smll.75763",
      type: "Research Article"
    },
    {
      id: 186,
      authors: "Chevella Maheshwari, Chalamala Balagangadhar Reddy, Manikumar Kodieswaran, Samit Kumar Nandi, Biman B Mandal",
      title: "Compartmentalized Dual‐Drug Injectable Hydrogel for Anti‐Inflammatory Activity and Osteoarthritic Cartilage Repair",
      journal: "Small",
      year: "2026",
      impactFactor: "11.8",
      doi: "  https://doi.org/10.1002/smll.74820",
      type: "Research Article"
    },
    {
      id: 187,
      authors: "Chittaranjan Mishra, Debasmita Sarkar, Chitra Jaiswal, Anuradha Kirtonia, Sumit Sarkar, Saurav Kumar, Mizuki Tenjimbayashi, Biman B Mandal, Uttam Manna",
      title: "Composite Liquid Marble Templated Millimetric Capsule With Tunable Rigidity, Porosity, and Thermal Reconfigurability Toward 3D Cell Culture",
      journal: "Advanced Materials",
      year: "2026",
      impactFactor: "29.1",
      doi: " https://doi.org/10.1002/adma.73815",
      type: "Research Article"
    },
    {
      id: 188,
      authors: "Chitra Jaiswal, Bibrita Bhar, Saki Sugihara, Biman B Mandal",
      title: "Bioengineered In Vitro 3D Cancer Models: A New Paradigm in Ethical and Predictive Oncology Research Toward Successful Pre-Clinical Drug Screening",
      journal: "Small",
      year: "2026",
      impactFactor: "11.8",
      doi: "https://doi.org/10.1002/smll.202513199",
      type: "Review Article"
    },
    {
      id: 189,
      authors: "Rajat Dadheech, Manikumar Kodieswaran, Biman B Mandal",
      title: "Engineered GelMA Microgels for Locoregional Doxorubicin Release and Apoptosis Induction in Oral Squamous Cell Carcinoma",
      journal: "ACS Biomaterials Science & Engineering",
      year: "2026",
      impactFactor: "5.5",
      doi: "https://doi.org/10.1021/acsbiomaterials.6c00489",
      type: "Research Article"
    },
    {
      id: 190,
      authors: "Rajiv Borah, Joseph Christakiran Moses, Jnanendra Upadhyay, Jitu Mani Das, Michael G Monaghan, Biman B Mandal",
      title: "Nonmulberry Silk Fibroin Doping Boosts Charge Transfer and Charge Injection in Aligned Polypyrrole‐Silk Scaffolds for Low‐Voltage Neurostimulation",
      journal: "ACS Applied Materials & Interfaces",
      year: "2025",
      impactFactor: "8.2",
      doi: "https://doi.org/10.1002/admi.202500842",
      type: "Research Article"
    },
  ],
  "2025": [
    {
      id: 191,
      authors: "Chitra Jaiswal, Saki Sugihara, Souradeep Dey, Ajay Kumar, Arpita Sharma, Raghvendra Gupta, Biman B Mandal",
      title: "Osteosarcoma-on-a-chip model mimicking intra-tumoral heterogeneity to interrogate tumor-associated macrophage reprogramming for immunotherapeutics",
      journal: "Biomaterials",
      year: "2025",
      impactFactor: "13.6",
      doi: "https://doi.org/10.1016/j.biomaterials.2025.123917",
      type: "Research Article"
    },
    {
      id: 192,
      authors: "Manikumar Kodieswaran, Rajat Dadheech, Debajyoti Pal, Chevella Maheshwari, Rupam Khatua, Samit Kumar Nandi, Biman B Mandal",
      title: "Instant Protection Nanospray Bandage Driven Anti-Scar Wound Healing",
      journal: "ACS Applied Materials & Interfaces",
      year: "2025",
      impactFactor: "8.2",
      doi: "https://doi.org/10.1021/acsami.5c15025",
      type: "Research Article"
    },
    {
      id: 193,
      authors: "Shabir Hassan, Zahra Rezael, Eder Luna, Dilara Yilmaz-Aykut, Myung Chul Lee, Ans Marie Perea, Anurag Jamaiyar, Nicole Bassous, Minoru Hirano, Fatima Mumtaza Toruk, Cholong Choi, Melin Becker, Iman Yazdi, Kadi Fan, Alan Eduardo Avila-Ramirez, David Ge, Reza Abdi, Sudeshna Fisch, Jeroen Leijten, Mark W Freinberg, Biman B Mandal, Ronglih Liao, Su Ryon Shin",
      title: "Injectable Self-Oxygenating Cardio-Protective and Tissue Adhesive Silk-Based Hydrogel for Alleviating Ischemia After MI Injury",
      journal: "SMALL",
      year: "2025",
      impactFactor: "12.1",
      doi: "https://doi.org/10.1002/smll.202312261",
      type: "Research Article"
    },
    {
      id: 194,
      authors: "Souradeep Dey, Pragya Mehra, Chitra Jaiswal, Tanmay Deepak Jadhav, Anuradha Kirtonia, Bibrita Bhar, Sruti Baibhab Mishra, Raghvendra Gupta, Biman B Mandal",
      title: "Multimodal induction of stem cells synergistically mediates enhanced cartilage-bone cross-talk in a 3D bioprinted human osteochondral microphysiological system",
      journal: "Biomaterials",
      year: "2025",
      impactFactor: "13.6",
      doi: "https://doi.org/10.1016/j.biomaterials.2025.123719",
      type: "Research Article"
    },
    {
      id: 1,
      authors: "Chitra Jaiswal, Souradeep Dey, Jayant Prasad, Raghvendra Gupta, Manoj Agarwala, Biman B Mandal",
      title: "3D bioprinted microfluidic based osteosarcoma-on-a chip model as a physiomimetic pre-clinical drug testing platform for anti-cancer drugs",
      journal: "Biomaterials",
      year: "2025",
      impactFactor: "13.6",
      doi: "https://doi.org/10.1016/j.biomaterials.2025.123267",
      type: "Research Article"
    },
    {
      id: 2,
      authors: "Swatilekha Hazra, Souradeep Dey, Biman B Mandal, Charanya Ramachandran",
      title: "Addition of Microscale Topographies to Silk Fibroin Film Modulates Corneal Endothelial Cell Behavior",
      journal: "ACS Biomaterials Science & Engineering",
      year: "2025",
      impactFactor: "5.5",
      doi: "https://doi.org/10.1021/acsbiomaterials.5c00200",
      type: "Research Article"
    }
  ],
  "2024": [
    {
      id: 3,
      authors: "Rajiv Borah, Joseph Christakiran Moses, Jnanendra Upadhyay, Jitu Moni Das, Biman B Mandal",
      title: "Non-mulberry silk fibroin functionalization enhances charge-transfer efficiency in aligned polypyrrole-silk composites for electrically stimulated neurite outgrowth",
      journal: "bioRxiv",
      year: "2024",
      impactFactor: "Preprint",
      doi: "https://doi.org/10.1101/2024.12.12.628243",
      type: "Preprint"
    },
    {
      id: 4,
      authors: "Saurav Kumar, Angana Borbora, Pritha Chakraborty, Hrisikesh Sarma, Ashutosh Bandyopadhyay, Akash Bose, Biman B Mandal, Mizuki Tenjimbayashi, Uttam Manna",
      title: "Controlled Chemical‐Patterning of Textile to Accelerate Anti‐Gravity Water Flow",
      journal: "Advanced Functional Materials",
      year: "2024",
      impactFactor: "19.0",
      doi: "https://doi.org/10.1002/adfm.202410955",
      type: "Research Article"
    },
    {
      id: 5,
      authors: "Souradeep Dey, Amritha Bhat, G. Janani, Vartik Shandilya, Raghvendra Gupta, Biman B. Mandal",
      title: "Microfluidic human physiomimetic liver model as a screening platform for drug induced liver injury",
      journal: "Biomaterials",
      year: "2024",
      volume: "310",
      pages: "122627",
      impactFactor: "12.9",
      doi: "https://doi.org/10.1016/j.biomaterials.2024.122627",
      type: "Research Article"
    },
    {
      id: 6,
      authors: "Bhar, Bibrita, Rajan Singh, Vaishak Ramesh, Souradeep Dey, Samit Nandi, Roy Paily and Biman B. Mandal",
      title: "Wearable e-Bandage with Antimicrobial Ionogel as an Integrated Electroceutical Device for Accelerated Wound Healing",
      journal: "ACS Materials Letters",
      year: "2024",
      impactFactor: "9.9",
      doi: "https://doi.org/10.1021/acsmaterialslett.4c00920",
      type: "Research Article"
    },
    {
      id: 7,
      authors: "Khatua, Rupam, Bibrita Bhar, Souradeep Dey, Chitra Jaiswal, J. Victoria, and Biman B. Mandal",
      title: "Advances in engineered nanosystems: immunomodulatory interactions for therapeutic applications",
      journal: "Nanoscale",
      year: "2024",
      impactFactor: "5.1",
      doi: "https://doi.org/10.1039/D4NR00680A",
      type: "Review"
    },
    {
      id: 8,
      authors: "Bandyopadhyay, Ashutosh, Baishali Ghibhela, Biman B. Mandal",
      title: "Current advances in engineering meniscal tissues: insights into 3D printing, injectable hydrogels and physical stimulation based strategies",
      journal: "Biofabrication",
      year: "2024",
      volume: "16",
      pages: "022006",
      impactFactor: "8.0",
      doi: "https://doi.org/10.1088/1758-5090/ad22f0",
      type: "Review"
    },
    {
      id: 9,
      authors: "Jaiswal, Chitra, Biman B. Mandal",
      title: "A 3D In Vitro Tri‐culture Hybrid Model Recapitulating Tumor Stromal Interaction of Triple‐Negative Breast Cancer as a High Throughput Anti‐Cancer Drug Screening Platform",
      journal: "Advanced Therapeutics",
      year: "2024",
      impactFactor: "2.6",
      doi: "https://doi.org/10.1002/adtp.202300450",
      type: "Research Article"
    },
    {
      id: 10,
      authors: "Hassan, Shabir, Zahra Rezaei, Eder Luna, Dilara Yilmaz-Aykut, Myung Chul Lee, Ana Marie Perea, Anurag Jamaiyar, Nicole Bassous, Minoru Hirano, Fatima Mumtaza Tourk, Cholong Choi, Malin Becker, Iman Yazdi, Kai Fan, Alan Eduardo Avila-Ramirez, David Ge, Reza Abdi, Sudeshna Fisch, Jeroen Leijten, Mark W. Feinberg, Biman B. Mandal, Ronglih Liao, Su Ryon Shin",
      title: "Injectable Self‐Oxygenating Cardio‐Protective and Tissue Adhesive Silk‐Based Hydrogel for Alleviating Ischemia After Mi Injury",
      journal: "Small",
      year: "2024",
      impactFactor: "12.1",
      doi: "https://doi.org/10.1002/smll.202312261",
      type: "Research Article"
    },
    {
      id: 11,
      authors: "Bandyopadhyay, Ashutosh, Baishali Ghibhela, Sayanti Shome, Debajyoti Pal, Samit K Nandi, Biman B. Mandal",
      title: "Silk-based injectable photocurable hydrogel loaded with autologous growth factors for patient-specific repair of meniscal defects in vivo",
      journal: "Applied Materials Today",
      year: "2024",
      volume: "37",
      pages: "102111",
      impactFactor: "6.9",
      doi: "https://doi.org/10.1016/j.apmt.2024.102111",
      type: "Research Article"
    },
    {
      id: 12,
      authors: "Bandyopadhyay, Ashutosh, Biman B. Mandal",
      title: "Photocrosslinkable silk-based bioinks embedded with growth factor loaded microspheres towards cell-free 3D printing approach for biomimetic regeneration of meniscal tissue",
      journal: "Applied Materials Today",
      year: "2024",
      volume: "36",
      pages: "102049",
      impactFactor: "6.9",
      doi: "https://doi.org/10.1016/j.apmt.2023.102049",
      type: "Research Article"
    },
    {
      id: 13,
      authors: "Singh, Yogendra Pratap, Ashutosh Bandyopadhyay, Souradeep Dey, Niranjan Bhardwaj, Biman B. Mandal",
      title: "Trends and advances in silk based 3D printing/bioprinting towards cartilage tissue engineering and regeneration",
      journal: "Progress in Biomedical Engineering",
      year: "2024",
      volume: "6",
      pages: "022002",
      impactFactor: "7.7",
      doi: "https://doi.org/10.1088/2516-1091/ad2d59",
      type: "Review"
    },
    {
      id: 14,
      authors: "Bhar, Bibrita, Eshani Das, Kodieswaran Manikumar, Biman B. Mandal",
      title: "3D Bioprinted Human Skin Model Recapitulating Native‐Like Tissue Maturation and Immunocompetence as an Advanced Platform for Skin Sensitization Assessment",
      journal: "Advanced Healthcare Materials",
      year: "2024",
      impactFactor: "9.6",
      doi: "https://doi.org/10.1002/adhm.202303312",
      type: "Research Article"
    },
    {
      id: 15,
      authors: "Ritvika Kushwaha, Souryadeep Dey, Kanika Gupta, Biman B. Mandal, Debapratim Das",
      title: "Secondary Chemical Cross-Linking to Improve Mechanical Properties in a Multifaceted Biocompatible Strain Sensor",
      journal: "ACS Applied Materials & Interfaces",
      year: "2024",
      volume: "16",
      issue: "4",
      pages: "5183-5195",
      impactFactor: "8.2",
      doi: "https://doi.org/10.1021/acsami.3c18247",
      type: "Research Article"
    },
    {
      id: 16,
      authors: "Bhunia, Bibhas K, Ashutosh Bandyopadhyay, Souradeep Dey, Biman.B. Mandal",
      title: "Silk-hydrogel functionalized with human decellularized Wharton's jelly extracellular matrix as a minimally invasive injectable hydrogel system for potential nucleus pulposus tissue replacement therapy",
      journal: "International Journal of Biological Macromolecules",
      year: "2024",
      volume: "254",
      pages: "127686",
      impactFactor: "8.5",
      doi: "https://doi.org/10.1016/j.ijbiomac.2023.127686",
      type: "Research Article"
    },
    {
      id: 17,
      authors: "Bandyopadhyay, Ashutosh, Baishali Ghibhela, Sayanti Shome, Samsamul Hoque, Samit K Nandi, Biman B. Mandal",
      title: "Photo‐Polymerizable Autologous Growth‐Factor Loaded Silk‐Based Biomaterial‐Inks toward 3D Printing‐Based Regeneration of Meniscus Tears",
      journal: "Advanced Biology",
      year: "2024",
      impactFactor: "2.6",
      doi: "https://doi.org/10.1002/adbi.202300710",
      type: "Research Article"
    },
    {
      id: 18,
      authors: "Bhar, Bibrita, Priyanka Ranta, Pavan Kumar Samudrala, Biman B. Mandal",
      title: "Omentum Extracellular Matrix-Silk Fibroin Hydroscaffold Promotes Wound Healing through Vascularization and Tissue Remodeling in the Diabetic Rat Model",
      journal: "ACS Biomaterials Science & Engineering",
      year: "2024",
      impactFactor: "5.5",
      doi: "https://doi.org/10.1021/acsbiomaterials.3c01877",
      type: "Research Article"
    },
    {
      id: 19,
      authors: "Morang, Samiran, Ashutosh Bandyopadhyay, Nobomi Borah, Annesha Kar, Biman B. Mandal, Niranjan Karak",
      title: "Photoluminescent Self-Healable Waterborne Polyurethane/Mo and S Codoped Graphitic Carbon Nitride Nanocomposite with Bioimaging and Encryption Capability",
      journal: "ACS Applied Bio Materials",
      year: "2024",
      volume: "7",
      issue: "3",
      pages: "1910–1924",
      impactFactor: "4.7",
      doi: "https://doi.org/10.1021/acsabm.3c01259",
      type: "Research Article"
    }
  ],
  "2023": [
    {
      id: 20,
      authors: "Bhardwaj, Nandana, Souradeep Dey, Bibrita Bhar, Biman.B. Mandal",
      title: "Bioprinted in vitro tissue models: an emerging platform for developing therapeutic interventions and disease modelling",
      journal: "Progress in Biomedical Engineering",
      year: "2023",
      volume: "6",
      issue: "1",
      pages: "012003",
      impactFactor: "7.7",
      doi: "https://doi.org/10.1088/2516-1091/ad10b4",
      type: "Review"
    },
    {
      id: 21,
      authors: "Boron, Nobomi, Muzamil Ahmad Rather, Bibrita Bhar, Biman B. Mandal, Manabendra Mandal, Niranjan Karak",
      title: "A robust epoxy nanocomposite with iron oxide decorated cellulose nanofiber as a sustained drug delivery vehicle for antibacterial drugs",
      journal: "New Journal of Chemistry",
      year: "2023",
      volume: "47",
      issue: "43",
      pages: "20010-20025",
      impactFactor: "2.5",
      doi: "https://doi.org/10.1039/D3NJ03412G",
      type: "Research Article"
    },
    {
      id: 22,
      authors: "Borbora, Angana, Yang Xu, Souradeep Dey, Xin Wang, Yuxing Yao, Biman B. Mandal, Xiaoguang Wang, Uttam Manna",
      title: "Lubricated Interfaces Enabling Simultaneous Pulsatile and Continuous Chemical Release Modes",
      journal: "Advanced Materials",
      year: "2023",
      volume: "35",
      issue: "31",
      pages: "2302264",
      impactFactor: "26.8",
      doi: "https://doi.org/10.1002/adma.202302264",
      type: "Research Article"
    },
    {
      id: 23,
      authors: "Hazra, Swatilekha, Souryadeep Dey, Biman B. Mandal, Charanya Ramachandran",
      title: "In vitro profiling of the extracellular matrix and integrins expressed by human corneal endothelial cells cultured on silk fibroin-based matrices",
      journal: "ACS Biomaterials Science & Engineering",
      year: "2023",
      volume: "9",
      issue: "5",
      pages: "2438-2451",
      impactFactor: "5.5",
      doi: "https://doi.org/10.1021/acsbiomaterials.2c01566",
      type: "Research Article"
    },
    {
      id: 24,
      authors: "Khadimul, Islam, Bibhas K. Bhunia, Gargi Mandal, Bedabara Nag, Chitra Jaiswal, Biman B. Mandal, Akshai Kumar",
      title: "Room-Temperature, Copper-Free, and Amine-Free Sonogashira Reaction in a Green Solvent: Synthesis of Tetraalkynylated Anthracenes and In Vitro Assessment of Their Cytotoxic Potentials",
      journal: "ACS Omega",
      year: "2023",
      volume: "8",
      issue: "19",
      pages: "16907-16926",
      impactFactor: "4.3",
      doi: "https://doi.org/10.1021/acsomega.3c00732",
      type: "Research Article"
    },
    {
      id: 25,
      authors: "Bandyopadhyay, Ashutosh, Baishali Ghibhela, Sayanti Shome, Biman B. Mandal",
      title: "Silk Based Photocrosslinkable Growth Factor Laden Injectable Hydrogel for Meniscus Defects",
      journal: "Tissue Engineering PART A",
      year: "2023",
      impactFactor: "2.9",
      type: "Research Article"
    },
    {
      id: 26,
      authors: "Bhar, Bibrita, Eshani Das, Kodieswaran Manikumar, Ashutosh Bandyopadhyay, Biman B. Mandal",
      title: "Silk based 3D printed human skin model for high-throughput screening of topical formulations",
      journal: "Tissue Engineering PART A",
      year: "2023",
      impactFactor: "2.9",
      type: "Research Article"
    },
    {
      id: 27,
      authors: "Dey, Souradeep, Amritha Bhat, G Janani, Ashutosh Bandyopadhyay, Vartik Shandilya, Raghvendra Gupta, Biman B. Mandal",
      title: "Perfusion bioreactor based 3D printed in vitro liver model for drug screening applications",
      journal: "Tissue Engineering PART A",
      year: "2023",
      impactFactor: "2.9",
      type: "Research Article"
    },
    {
      id: 28,
      authors: "Jaiswal, Chitra, Ashutosh Bandyopadhyay, Biman B. Mandal",
      title: "Development of silk fibroin-based tri-culture 3D in vitro model of breast cancer for high throughput anticancer drug screening",
      journal: "Tissue Engineering PART A",
      year: "2023",
      impactFactor: "2.9",
      type: "Research Article"
    },
    {
      id: 29,
      authors: "Jaiswal, Chitra, Tarishi Gupta, Praveen Kumar Jadi, Joseph Christakiran Moses, Biman B. Mandal",
      title: "Injectable anti-cancer drug loaded silk-based hydrogel for the prevention of cancer recurrence and post-lumpectomy tissue regeneration aiding triple-negative breast cancer therapy",
      journal: "Biomaterials Advances",
      year: "2023",
      volume: "145",
      pages: "213224",
      impactFactor: "6.0",
      doi: "https://doi.org/10.1016/j.bioadv.2022.213224",
      type: "Research Article"
    },
    {
      id: 30,
      authors: "G. Janani, Li Zhang, Stephen F. Badylak, Biman B. Mandal",
      title: "Silk fibroin bioscaffold from Bombyx mori and Antheraea assamensis elicits a distinct host response and macrophage activation paradigm in vivo and in vitro",
      journal: "Biomaterials Advances",
      year: "2023",
      volume: "145",
      pages: "213223",
      impactFactor: "6.0",
      doi: "https://doi.org/10.1016/j.bioadv.2022.213223",
      type: "Research Article"
    },
    {
      id: 31,
      authors: "Mandal, Santanu, Anyam VVNGSV Kishore, Sumantra Mandal, Bibrita Bhar, Biman B. Mandal, Samit Kumar Nandi, Mangal Roy",
      title: "Controlled nano Cu precipitation through age treatment: A method to enhance the biodegradation, mechanical, antimicrobial properties and biocompatibility of Fe-20Mn-3Cu alloys",
      journal: "Acta Biomaterialia",
      year: "2023",
      volume: "168",
      pages: "650-669",
      impactFactor: "9.6",
      doi: "https://doi.org/10.1016/j.actbio.2023.07.004",
      type: "Research Article"
    },
    {
      id: 32,
      authors: "Mehrotra, Shreya, Souradeep Dey, Kunj Sachdeva, Sujuta Mohanty, Biman B. Mandal",
      title: "Recent advances in tailoring stimuli responsive hybrid scaffolds for cardiac tissue engineering and allied applications",
      journal: "Journal of Materials Chemistry B",
      year: "2023",
      impactFactor: "5.7",
      doi: "https://doi.org/10.1039/D3TB00450C",
      type: "Review"
    },
    {
      id: 33,
      authors: "Morang, Samiran, Ashutosh Bandyopadhyay, Biman B. Mandal, Niranjan Karak",
      title: "Asymmetric hard domain-induced robust resilient biocompatible self-healable waterborne polyurethane for biomedical applications",
      journal: "ACS Applied Bio Materials",
      year: "2023",
      volume: "6",
      issue: "7",
      pages: "2771-2784",
      impactFactor: "4.7",
      doi: "https://doi.org/10.1021/acsabm.3c00243",
      type: "Research Article"
    },
    {
      id: 34,
      authors: "Morang, Samiran, Ashutosh Bandyopadhyay, Jai Hind Rajput, Biman B. Mandal, Atharva Poundarik, Niranjan Karak",
      title: "Robust self-healable and three-dimensional printable thermoplastic elastomeric waterborne polyurethane for artificial muscle and biomedical scaffold applications",
      journal: "ACS Applied Polymer Materials",
      year: "2023",
      volume: "5",
      issue: "10",
      pages: "8518-8532",
      impactFactor: "4.7",
      doi: "https://doi.org/10.1021/acsapm.3c01627",
      type: "Research Article"
    },
    {
      id: 35,
      authors: "Shome, Sayanti, M. Kodieswaran, Rajat Dadheech, Maheshwari Chevella, Sreemoyee Sensharma, Sanu Awasthi, Ashutosh Bandyopadhyay, Biman B. Mandal",
      title: "Recent advances in platelet-rich plasma and its derivatives: therapeutic agents for tissue engineering and regenerative medicine",
      journal: "Progress in Biomedical Engineering",
      year: "2023",
      volume: "6",
      pages: "012004",
      impactFactor: "7.7",
      doi: "https://doi.org/10.1088/2516-1091/ad1338",
      type: "Review"
    },
    {
      id: 36,
      authors: "Dey, Souradeep, Chitra Jaiswal, Sayanti Shome, Bibrita Bhar, Ashutosh Bandyopadhyay, Kodieswaran Manikumar, Rajat Dadheech, Biman B. Mandal",
      title: "Photocrosslinkable silk-based biomaterials for regenerative medicine and healthcare applications",
      journal: "Regenerative Engineering and Translational Medicine",
      year: "2023",
      volume: "9",
      issue: "2",
      pages: "181-201",
      impactFactor: "1.9",
      doi: "https://doi.org/10.1007/s40883-022-00277-8",
      type: "Research Article"
    },
    {
      id: 37,
      authors: "Islam, Khadimul, Bibhas K Bhunia, Gargi Mandal, Bedabara Nag, Chitra Jaiswal, Biman B. Mandal, Akshai Kumar",
      title: "Room-Temperature, Copper-Free, and Amine-Free Sonogashira Reaction in a Green Solvent: Synthesis of Tetraalkynylated Anthracenes and In Vitro Assessment of Their Cytotoxic Potentials",
      journal: "ACS Omega",
      year: "2023",
      volume: "8",
      issue: "19",
      pages: "16907-16926",
      impactFactor: "4.3",
      doi: "https://doi.org/10.1021/acsomega.3c00732",
      type: "Research Article"
    },
    {
      id: 204,
      authors: "Morang, Samiran, Ashutosh Bandyopadhyay, Jay Hind Rajput, Biman B. Mandal*, Atharva Poundarik, Niranjan Karak",
      title: "Robust Self-Healable and Three-Dimensional Printable Thermoplastic Elastomeric Waterborne Polyurethane for Artificial Muscle and Biomedical Scaffold Applications",
      journal: "ACS Applied Polymer Materials",
      year: "2023",
      impactFactor: "4.7",
      doi: "https://doi.org/10.1021/acsapm.3c01627",
      type: "Research Article"
    }
  ],
  "2022": [
    {
      id: 38,
      authors: "Kazuharu Arakawa, Nobuaki Kono, Ali D Malay, Ayaka Tateishi, Nao Ifuku, Hiroyasu Masunaga, Ryota Sato, Kousuke Tsuchiya, Rintaro Ohtoshi, Daniel Pedrazzoli, Asaka Shinohara, Yusuke Ito, Hiroyuki Nakamura, Akio Tanikawa, Yuya Suzuki, Takeaki Ichikawa, Shohei Fujita, Masayuki Fujiwara, Masaru Tomita, Sean J Blamires, Jo-Ann Chuah, Hamish Craig, Choon P Foong, Gabriele Greco, Juan Guan, Chris Holland, David L Kaplan, Kumar Sudesh, Biman B Mandal, Y Norma-Rashid, Nur A Oktaviani, Rucsanda C Preda, Nicola M Pugno, Rangam Rajkhowa, Xiaoqin Wang, Kenjiro Yazawa, Zhaozhu Zheng, Keiji Numata",
      title: "1000 spider silkomes: Linking sequences to silk physical properties",
      journal: "Science Advances",
      year: "2022",
      volume: "8",
      pages: "eabo60432",
      impactFactor: "12.5",
      doi: "https://doi.org/10.1126/sciadv.abo6043",
      type: "Research Article"
    },
    {
      id: 39,
      authors: "Yogendra Pratap Singh, Joseph Christakiran Moses, Ashutosh Bandyopadhyay, Biman B. Mandal",
      title: "3D Bioprinted Silk-Based In Vitro Osteochondral Model for Osteoarthritis Therapeutics",
      journal: "Advanced Healthcare Materials",
      year: "2022",
      impactFactor: "9.6",
      doi: "https://doi.org/10.1002/adhm.202200209",
      type: "Research Article"
    },
    {
      id: 40,
      authors: "Moses, Joseph Christakiran, Biman B. Mandal",
      title: "Mesoporous Silk-Bioactive Glass Nanocomposites as Drug Eluting Multifunctional Conformal Coatings for Improving Osseointegration and Bactericidal Properties of Metal Implants",
      journal: "ACS Applied Materials & Interfaces",
      year: "2022",
      volume: "14",
      pages: "14961–14980",
      impactFactor: "8.2",
      doi: "https://doi.org/10.1021/acsami.2c00093",
      type: "Research Article"
    },
    {
      id: 41,
      authors: "Biman B Mandal, Chitta R Patra, Subhas C Kundu",
      title: "Biomedical materials research in India",
      journal: "Biomedical Materials",
      year: "2022",
      impactFactor: "3.7",
      doi: "https://doi.org/10.1088/1748-605X/ac8902",
      type: "Review"
    },
    {
      id: 42,
      authors: "G. Janani, Smriti Priya, Souradeep Dey, Biman B. Mandal",
      title: "Mimicking Native Liver Lobule Microarchitecture In Vitro with Parenchymal and Non-parenchymal Cells Using 3D Bioprinting for Drug Toxicity and Drug Screening Applications",
      journal: "ACS Applied Materials & Interfaces",
      year: "2022",
      volume: "14",
      pages: "10167-10186",
      impactFactor: "8.2",
      doi: "https://doi.org/10.1021/acsami.2c00312",
      type: "Research Article"
    },
    {
      id: 43,
      authors: "Ramakrishnan, Rashmi, Dimple Chouhan, Harikrishnan Vijayakumar Sreelatha, Sabareeswaran Arumugam, Biman B. Mandal, Lissy K Krishnan",
      title: "Silk Fibroin-Based Bioengineered Scaffold for Enabling Hemostasis and Skin Regeneration of Critical-Size Full-Thickness Heat-Induced Burn Wounds",
      journal: "ACS Biomaterials Science & Engineering",
      year: "2022",
      impactFactor: "5.5",
      doi: "https://doi.org/10.1021/acsbiomaterials.2c00328",
      type: "Research Article"
    },
    {
      id: 44,
      authors: "Bibrita Bhar, Bijayashree Chakraborty, Samit K. Nandi, Biman B. Mandal",
      title: "Silk-based phyto-hydrogel formulation expedites key events of wound healing in full-thickness skin defect model",
      journal: "International Journal of Biological Macromolecules",
      year: "2022",
      volume: "203",
      pages: "623-637",
      impactFactor: "8.5",
      doi: "https://doi.org/10.1016/j.ijbiomac.2022.01.142",
      type: "Research Article"
    },
    {
      id: 45,
      authors: "Ashutosh Bandyopadhyay, Biman B. Mandal, Nandana Bhardwaj",
      title: "3D bioprinting of photo‐crosslinkable silk methacrylate (SilMA)‐polyethylene glycol diacrylate (PEGDA) bioink for cartilage tissue engineering",
      journal: "Journal of Biomedical Materials Research Part A",
      year: "2022",
      volume: "110",
      pages: "884-898",
      impactFactor: "3.9",
      doi: "https://doi.org/10.1002/jbm.a.37336",
      type: "Research Article"
    },
    {
      id: 46,
      authors: "Mahendiran, Balaji, Shalini Muthusamy, G Janani, Biman B. Mandal, Selvakumar Rajendran, Gopal Shankar Krishnakumar",
      title: "Surface Modification of Decellularized Natural Cellulose Scaffolds with Organosilanes for Bone Tissue Regeneration",
      journal: "ACS Biomaterials Science & Engineering",
      year: "2022",
      volume: "8",
      issue: "5",
      pages: "2000-2015",
      impactFactor: "5.5",
      doi: "https://doi.org/10.1021/acsbiomaterials.1c01502",
      type: "Research Article"
    },
    {
      id: 47,
      authors: "Biswas, Saptarshi, Bibhas K Bhunia, G Janani, Biman B. Mandal",
      title: "Silk Fibroin Based Formulations as Potential Hemostatic Agents",
      journal: "ACS Biomaterials Science & Engineering",
      year: "2022",
      pages: "2654–2663",
      impactFactor: "5.5",
      doi: "https://doi.org/10.1021/acsbiomaterials.2c00170",
      type: "Research Article"
    },
    {
      id: 48,
      authors: "Araghni Bhattacharya, Satyajit Mahata, Ashutosh Bandyopadhyay, Biman B. Mandal, Vadivelu Manivannan",
      title: "Application of 2, 4, 5‐Tris (2‐pyridyl) imidazole as ' Turn‐Off' Fluorescence Sensor for Cu (II) and Hg (II) ions and in vitro Cell Imaging",
      journal: "Luminescence",
      year: "2022",
      impactFactor: "3.0",
      doi: "https://doi.org/10.1002/bio.4232",
      type: "Research Article"
    },
    {
      id: 49,
      authors: "Arnab Chakraborty, Chitra Jaiswal, Atikur Hassan, Saurabh Kumar, Khushwant Singh, Biman B Mandal, Neeladri Das",
      title: "Tunable and improved antiproliferative activity of Pt (II)–based organometallics bearing alkynyls and 1, 2, 3‐triazole moieties",
      journal: "Applied Organometallic Chemistry",
      year: "2022",
      impactFactor: "3.7",
      doi: "https://doi.org/10.1002/aoc.6711",
      type: "Research Article"
    },
    {
      id: 50,
      authors: "Satyajit Mahata, Sandeep Kumar, Souradeep Dey, Biman B. Mandal, Vadivelu Manivannan",
      title: "A probe with hydrazinecarbothioamide and 1, 8-naphthalimide groups for 'turn-on' fluorescence detection of Hg2+ and Ag+ ions and live-cell imaging studies",
      journal: "Inorganica Chimica Acta",
      year: "2022",
      volume: "535",
      pages: "120876",
      impactFactor: "3.2",
      doi: "https://doi.org/10.1016/j.ica.2022.120876",
      type: "Research Article"
    },
    {
      id: 51,
      authors: "Satyajit Mahata, Souradeep Dey, Biman B. Mandal, Vadivelu Manivannan",
      title: "3-(2-Hydroxyphenyl) imidazo [5, 1-a] isoquinoline as Cu (II) sensor, its Cu (II) complex for selective detection of CN–ion and biological compatibility",
      journal: "Journal of Photochemistry and Photobiology A: Chemistry",
      year: "2022",
      pages: "113795",
      impactFactor: "4.7",
      doi: "https://doi.org/10.1016/j.jphotochem.2022.113795",
      type: "Research Article"
    },
    {
      id: 52,
      authors: "Shreya Mehrotra, Bruna Alice Gomes de Melo, Mario Miscuglio, Kiavash Kiaee, Su Ryon Shin, Biman B. Mandal",
      title: "Mimicking Native Heart Tissue Physiology and Pathology in Silk Fibroin Constructs Through Perfusion-based Dynamic Mechanical Stimulation Microdevice",
      journal: "Advanced Healthcare Materials",
      year: "2022",
      volume: "11",
      pages: "2101678",
      impactFactor: "9.6",
      doi: "https://doi.org/10.1002/adhm.202101678",
      type: "Research Article"
    },
    {
      id: 53,
      authors: "Joseph Christakiran Moses, Souradeep Dey, Ashutosh Bandyopadhyay, Manoj Agarwala, Biman B Mandal",
      title: "Silk based bioengineered diaphyseal cortical bone unit enclosing an implantable bone marrow towards atrophic non-union grafting",
      journal: "Advanced Healthcare Materials",
      year: "2022",
      volume: "11",
      issue: "6",
      pages: "e2102031",
      impactFactor: "9.6",
      doi: "https://doi.org/10.1002/adhm.202102031",
      type: "Research Article"
    }
  ],
  "2021": [
    {
      id: 54,
      authors: "Shreya Mehrotra, Rishabh Deo Singh, Ashutosh Bandyopadhyay, G Janani, Souradeep Dey, Biman B. Mandal",
      title: "Engineering Microsphere Loaded Non-Mulberry Silk-based 3D Bioprinted Vascularized Cardiac Patches with Oxygen-Releasing and Immunomodulatory Potential",
      journal: "ACS Applied Materials and Interfaces",
      year: "2021",
      volume: "13",
      issue: "43",
      pages: "50744–50759",
      impactFactor: "8.2",
      doi: "https://doi.org/10.1021/acsami.1c14118",
      type: "Research Article"
    },
    {
      id: 55,
      authors: "Prerak Gupta, Gaurab Ranjan Chaudhuri, G. Janani, Manoj Agarwala, Debaki Ghosh, Samit K. Nandi, Biman B. Mandal",
      title: "Functionalized Silk Vascular Grafts with Decellularized Human Wharton's Jelly Improves Remodeling via Immunomodulation in Rabbit Jugular Vein",
      journal: "Advanced Healthcare Materials",
      year: "2021",
      volume: "10",
      issue: "19",
      pages: "2100750",
      impactFactor: "9.6",
      doi: "https://doi.org/10.1002/adhm.202100750",
      type: "Research Article"
    },
    {
      id: 56,
      authors: "Katherine L Lorentz, Prerak Gupta, Mostafa S Shehabeldin, Eoghan M Cunnane, Aneesh K Ramaswamy, Kostas Verdelis, Morgan V Fedorchak, Steven R Little, Justin S Weinbaum, Charles S Sfeir, Biman B Mandal, David A Vorp",
      title: "CCL2 loaded microparticles promote acute patency in silk-based vascular grafts implanted in rat aortae",
      journal: "Acta Biomaterialia",
      year: "2021",
      volume: "135",
      pages: "126-138",
      impactFactor: "9.5",
      doi: "https://doi.org/10.1016/j.actbio.2021.08.049",
      type: "Research Article"
    },
    {
      id: 57,
      authors: "Yogendra Pratap Singh, Joseph Christakiran Moses, Nandana Bhardwaj, Biman B. Mandal",
      title: "Overcoming the dependence on animal models for osteoarthritis therapeutics–the promises and prospects of in vitro models",
      journal: "Advanced Healthcare Materials",
      year: "2021",
      volume: "10",
      issue: "20",
      pages: "2100961",
      impactFactor: "9.6",
      doi: "https://doi.org/10.1002/adhm.202100961",
      type: "Review"
    },
    {
      id: 58,
      authors: "Bibrita Bhar, Dimple Chouhan, Nakhul Pai, Biman B. Mandal",
      title: "Harnessing Multifaceted Next Generation Technologies for Improved Skin Wound Healing",
      journal: "ACS Applied Bio Materials",
      year: "2021",
      volume: "4",
      pages: "7738–7763",
      impactFactor: "4.7",
      doi: "https://doi.org/10.1021/acsabm.1c00880",
      type: "Review"
    },
    {
      id: 59,
      authors: "Prerak Gupta, Biman B. Mandal",
      title: "Tissue‐Engineered Vascular Grafts: Emerging Trends and Technologies",
      journal: "Advanced Functional Materials",
      year: "2021",
      volume: "31",
      issue: "33",
      pages: "2100027",
      impactFactor: "19",
      doi: "https://doi.org/10.1002/adfm.202100027",
      type: "Review"
    },
    {
      id: 60,
      authors: "Prerak Gupta, Biman B Mandal",
      title: "Silk biomaterials for vascular tissue engineering applications",
      journal: "Acta Biomaterialia",
      year: "2021",
      volume: "134",
      pages: "79-106",
      impactFactor: "9.5",
      doi: "https://doi.org/10.1016/j.actbio.2021.08.004",
      type: "Review"
    },
    {
      id: 61,
      authors: "Arpita Shome, Joseph Moses, Adil Rather, Biman B. Mandal, Uttam Manna",
      title: "Unconventional and Facile Fabrication of Chemically Reactive Silk Fibroin Sponges for Environmental Remediation",
      journal: "ACS Applied Materials and Interfaces",
      year: "2021",
      volume: "13",
      pages: "24258-24271",
      impactFactor: "8.2",
      doi: "https://doi.org/10.1021/acsami.1c03150",
      type: "Research Article"
    },
    {
      id: 62,
      authors: "Pran Nandi, Jadi Praveen, Kanu Das, Siriyara Pratap, Biman B. Mandal, Akshai Kumar",
      title: "Synthesis of NNN Chiral Ruthenium Complexes and their Cytotoxicity Studies",
      journal: "Inorganic Chemistry",
      year: "2021",
      volume: "60",
      pages: "7422-7432",
      impactFactor: "4.7",
      doi: "https://doi.org/10.1021/acs.inorgchem.1c00698",
      type: "Research Article"
    },
    {
      id: 63,
      authors: "Satyajit Mahata, G. Janani, Biman B. Mandal, Vadivelu Manivannan",
      title: "A Coumarin based visual and fluorometric probe for selective detection of Al(III), Cr(III) and Fe(III) ions through “turn-on” response and its biological application",
      journal: "Journal of Photochemistry and Photobiology A: Chemistry",
      year: "2021",
      volume: "417",
      pages: "113340",
      impactFactor: "4.7",
      doi: "https://doi.org/10.1016/j.jphotochem.2021.113340",
      type: "Research Article"
    },
    {
      id: 64,
      authors: "Bibhas K. Bhunia, Dey S, Bandyopadhyay A, Biman B Mandal",
      title: "3D printing of annulus fibrosus anatomical equivalents recapitulating angle-ply architecture for intervertebral disc replacement",
      journal: "Applied Materials Today",
      year: "2021",
      volume: "23",
      pages: "101031",
      impactFactor: "6.9",
      doi: "https://doi.org/10.1016/j.apmt.2021.101031",
      type: "Research Article"
    },
    {
      id: 65,
      authors: "Janani G, Biman B Mandal",
      title: "Mimicking Physiologically Relevant Hepatocyte Zonation Using Immunomodulatory Silk Liver Extracellular Matrix Scaffolds toward a Bioartificial Liver Platform",
      journal: "ACS Applied Materials and Interfaces",
      year: "2021",
      volume: "13",
      pages: "24401−24421",
      impactFactor: "8.2",
      doi: "https://doi.org/10.1021/acsami.1c00719",
      type: "Research Article"
    },
    {
      id: 66,
      authors: "Deepika Arora, Bibhas K. Bhunia, G. Janani, Biman B Mandal",
      title: "Bioactive three-dimensional silk composite in vitro tumoroid models for high throughput screening of anticancer drugs",
      journal: "Journal Colloid and Interface Science",
      year: "2021",
      volume: "589",
      pages: "438-452",
      impactFactor: "9.7",
      doi: "https://doi.org/10.1016/j.jcis.2021.01.010",
      type: "Research Article"
    },
    {
      id: 67,
      authors: "Dibyangana Parbat, Bibhas Bhunia, Biman B. Mandal, Uttam Manna",
      title: "Bioinspired Underwater Super-Oil-Wettability for Controlling Platelet Adhesion",
      journal: "Chemistry - An Asian Journal",
      year: "2021",
      volume: "16",
      pages: "1-6",
      impactFactor: "3.3",
      doi: "https://doi.org/10.1002/asia.202100143",
      type: "Research Article"
    },
    {
      id: 68,
      authors: "Junmin Lee, Shreya Mehrotra, Elaheh Zare-Eelanjegh, Raquel Rodrigues, Alireza Akbarinejad, David Ge, Luca Amato, Kiavash Kiaee, YongCong Fang, Aliza Rosenkranz, Wendy Keung, Biman B. Mandal, Ronald A Li, Ting Zhang, HeaYeon Lee, Mehmet Remzi Dokmeci, Yu Shrike Zhang, Ali Khademhosseini, Su Ryon Shin",
      title: "A Heart-Breast Cancer-on-a-Chip Platform for Disease Modeling and Monitoring of Cardiotoxicity Induced by Cancer Chemotherapy",
      journal: "Small",
      year: "2021",
      volume: "17",
      pages: "2004258",
      impactFactor: "12.1",
      doi: "https://doi.org/10.1002/smll.202004258",
      type: "Research Article"
    }
  ],
  "2020": [
    {
      id: 69,
      authors: "Ankit Gangrade, Biman B Mandal",
      title: "Drug delivery of anticancer drugs from injectable 3D porous silk scaffold for prevention of gastric cancer growth and recurrence",
      journal: "ACS Biomaterials Science & Engineering",
      year: "2020",
      volume: "6",
      pages: "6195–6206",
      impactFactor: "5.5",
      doi: "https://doi.org/10.1021/acsbiomaterials.0c01043",
      type: "Research Article"
    },
    {
      id: 70,
      authors: "Vinod Morya, Shanka Walia, Biman B Mandal, Chinmay Ghoroi, Dhiraj Bhatia",
      title: "Functional DNA based hydrogels: Development, properties and biological applications",
      journal: "ACS Biomaterials Science & Engineering",
      year: "2020",
      volume: "6",
      pages: "6021–6035",
      impactFactor: "5.5",
      doi: "https://doi.org/10.1021/acsbiomaterials.0c01125",
      type: "Research Article"
    },
    {
      id: 71,
      authors: "Shreya Mehrotra, Bruna A.G. de Melo, Minoru Hirano, Wendy Kung, Ronald A. Li, Biman B. Mandal, Su Ryon Shin",
      title: "Non-mulberry Silk Based Ink for Fabricating Mechanically Robust Cardiac Patches and Endothelialized Myocardium-on-a-chip Application",
      journal: "Advanced Functional Materials",
      year: "2020",
      volume: "30",
      pages: "1907436",
      impactFactor: "19",
      doi: "https://doi.org/10.1002/adfm.201907436",
      type: "Research Article"
    },
    {
      id: 194,
      authors: "Eoghan M. Cunnane, Katherine L. Lorentz, Aneesh K. Ramaswamy, Prerak Gupta, Biman B. Mandal, Fergal J. O’Brien, Justin S. Weinbaum and David A. Vorp",
      title: "Extracellular Vesicles Enhance the Remodeling of Cell-Free Silk Vascular Scaffolds in Rat Aortae",
      journal: "ACS Applied Materials and Interfaces",
      year: "2020",
      volume: "12",
      pages: "26955–26965",
      impactFactor: "8.2",
      doi: "https://doi.org/10.1021/acsami.0c06609",
      type: "Research Article"
    },
    {
      id: 195,
      authors: "Ankit Gangrade, Basveshwar Gawali, Praveen Kumar Jadi, Vegi G. M. Naidu and Biman B. Mandal*",
      title: "Photo-Electro Active Nanocomposite Silk Hydrogel for Spatiotemporal Controlled Release of Chemotherapeutics: An in vivo approach towards suppressing solid tumor growth",
      journal: "ACS Applied Materials and Interfaces",
      year: "2020",
      volume: "12",
      pages: "27905–27916",
      impactFactor: "8.2",
      doi: "https://doi.org/10.1021/acsami.0c02470",
      type: "Research Article"
    },
    {
      id: 196,
      authors: "Prerak Gupta, Katherine L. Lorentz, Darren G. Haskett, Eoghan M. Cunnane, Aneesh K. Ramaswamy, Justin S. Weinbaum, David A. Vorp* and Biman B. Mandal*",
      title: "Bioresorbable silk grafts for small diameter vascular tissue engineering applications: In vitro and in vivo functional analysis",
      journal: "Acta Biomaterialia",
      year: "2020",
      volume: "105",
      pages: "146-158",
      impactFactor: "9.6",
      doi: "https://doi.org/10.1016/j.actbio.2020.01.020",
      type: "Research Article"
    },
    {
      id: 197,
      authors: "Charanya Ramachandran*, Prerak Gupta, Swatilekha Hazra and Biman B Mandal*",
      title: "In vitro culture of human corneal endothelium on silk fibroin films for tissue regeneration",
      journal: "Translational Vision Science & Technology",
      year: "2020",
      volume: "9",
      pages: "12",
      impactFactor: "3.2",
      doi: "https://doi.org/10.1167/tvst.9.4.12",
      type: "Research Article"
    },
    {
      id: 198,
      authors: "Ila Verma, Ashim Malakar, Abhijit Gogo, K. Anki Reddy, Manishekhar Kumar, Biman B. Mandal, G. Krishnamoorthy",
      title: "Pyridyl substitution control dynamics and shape dependence of fluorescent aggregates",
      journal: "Journal of Photochemistry and Photobiology A: Chemistry",
      year: "2020",
      volume: "392",
      pages: "112405",
      impactFactor: "4.7",
      doi: "https://doi.org/10.1016/j.jphotochem.2020.112405",
      type: "Research Article"
    },
    {
      id: 199,
      authors: "Satyajit Mahata, Araghni Bhattacharya, Jadi Praveen Kumar, Biman B. Mandal, Vadivelu Manivannan",
      title: "Naked-eye detection of Pd2+ ion using a highly selective fluorescent heterocyclic probe by “turn-off” response and in-vitro live cell imaging",
      journal: "Journal of Photochemistry and Photobiology A: Chemistry",
      year: "2020",
      volume: "394",
      pages: "112441",
      impactFactor: "4.7",
      doi: "https://doi.org/10.1016/j.jphotochem.2020.112441",
      type: "Research Article"
    },
    {
      id: 200,
      authors: "Joseph Christakiran Moses, Triya Saha, and Biman B. Mandal*",
      title: "Chondroprotective and osteogenic effects of silk-based bioinks in developing 3D bioprinted osteochondral interface",
      journal: "Bioprinting",
      year: "2020",
      volume: "17",
      pages: "e00067",
      doi: "https://doi.org/10.1016/j.bprint.2019.e00067",
      type: "Research Article"
    },
    {
      id: 201,
      authors: "Ashutosh Bandyopadhyay, Biman B. Mandal*",
      title: "3D Printed Silk-based Biomimetic Tri-layered Meniscus for Potential Patient Specific Implantation",
      journal: "Biofabrication",
      year: "2020",
      volume: "12",
      pages: "015003",
      impactFactor: "8.0",
      doi: "https://doi.org/10.1088/1758-5090/ab40fa",
      type: "Research Article"
    },
    {
      id: 202,
      authors: "Dimple Chouhan and Biman B Mandal*",
      title: "Silk biomaterials in wound healing and skin regeneration therapeutics: From bench to bedside",
      journal: "Acta Biomaterialia",
      year: "2020",
      volume: "103",
      pages: "24-51",
      impactFactor: "9.5",
      doi: "https://doi.org/10.1016/j.actbio.2019.11.050",
      type: "Review"
    },
    {
      id: 203,
      authors: "Ashish A Prabhu, Jadi P. Kumar, Biman B. Mandal*, Venkata V Dasu*",
      title: "High cell density cultivation for enhanced production of recombinant human interferon gamma (rhIFN-γ) using Glucose/Methanol carbon source and exploring the antitumor activity for potential biomedical applications",
      journal: "Biotechnology and Applied Biochemistry",
      year: "2020",
      impactFactor: "2.7",
      doi: "https://doi.org/10.1002/bab.1868",
      type: "Research Article"
    },
  ],
  "2019": [
    {
      id: 72,
      authors: "Guru Janani, Manishekhar Kumar, Dimple Chouhan, Joseph Moses, Ankit Gangrade, Sohenii Bhattacharjee, Biman B. Mandal",
      title: "An insight into silk-based biomaterials: From physico-chemical attributes to recent biomedical applications",
      journal: "ACS Applied Bio Materials",
      year: "2019",
      volume: "2",
      pages: "5460-5491",
      impactFactor: "4.7",
      doi: "https://doi.org/10.1021/acsabm.9b00576",
      type: "Review"
    },
    {
      id: 73,
      authors: "Ankit Gangrade, Biman B. Mandal",
      title: "Injectable Carbon Nanotube Impregnated Silk Based Multifunctional Hydrogel for Localized Targeted and On-Demand Anticancer Drug Delivery",
      journal: "ACS Biomaterials Science & Engineering",
      year: "2019",
      volume: "5",
      pages: "2365-2381",
      impactFactor: "5.5",
      doi: "https://doi.org/10.1021/acsbiomaterials.9b00416",
      type: "Research Article"
    },
    {
      id: 74,
      authors: "Dimple Chouhan, Namit Dey, Nandana Bhardwaj, Biman B. Mandal",
      title: "Emerging and innovative approaches for wound healing and skin regeneration: Current status and advances",
      journal: "Biomaterials",
      year: "2019",
      volume: "216",
      pages: "119267",
      impactFactor: "12.9",
      doi: "https://doi.org/10.1016/j.biomaterials.2019.119267",
      type: "Review"
    },
    {
      id: 75,
      authors: "Dimple Chouhan, Piyali Das, Naresh Thatikonda, Samit K. Nandi, My Hedhammar, Biman B. Mandal",
      title: "Silkworm silk matrices coated with functionalized spider silk accelerate healing of diabetic wounds",
      journal: "ACS Biomaterials Science & Engineering",
      year: "2019",
      volume: "5",
      pages: "3537-3548",
      impactFactor: "5.5",
      doi: "https://doi.org/10.1021/acsbiomaterials.9b00514",
      type: "Research Article"
    },
    {
      id: 76,
      authors: "Piyali Das, Yogendra Pratap Singh, Biman B. Mandal, Samit Kumar Nandi",
      title: "Tissue-derived decellularized extracellular matrices toward cartilage repair and regeneration",
      journal: "Methods in Cell Biology",
      year: "2019",
      volume: "157",
      pages: "185-221",
      impactFactor: "1.4",
      doi: "https://doi.org/10.1016/bs.mcb.2019.11.005",
      type: "Review"
    },
    {
      id: 77,
      authors: "Dimple Chouhan, Tshewuzo-u Lohe, Naresh Thatikonda, VGM Naidu, My Hedhammar, Biman B. Mandal",
      title: "Silkworm silk scaffolds functionalized with recombinant spider silk containing a fibronectin motif promotes healing of full-thickness burn wounds",
      journal: "ACS Biomaterials Science & Engineering",
      year: "2019",
      volume: "5",
      pages: "4634-4645",
      impactFactor: "5.5",
      doi: "https://doi.org/10.1021/acsbiomaterials.9b00887",
      type: "Research Article"
    },
    {
      id: 78,
      authors: "Joseph Christakiran Moses, Mainak Dey, K. Bavya Devi, Mangal Roy, Samit K. Nandi, Biman B. Mandal",
      title: "Synergistic effects of silicon/zinc doped brushite and silk scaffolding in augmenting the osteogenic and angiogenic potential of composite biomimetic bone grafts",
      journal: "ACS Biomaterials Science & Engineering",
      year: "2019",
      volume: "5",
      pages: "1462-1475",
      impactFactor: "5.5",
      doi: "https://doi.org/10.1021/acsbiomaterials.8b01350",
      type: "Research Article"
    },
    {
      id: 79,
      authors: "Nabanita Saha, Rushita Shah, Prerak Gupta, Biman B. Mandal, Radostina Alexandrova, Maja Dutour Sikiric, Petr Sáha",
      title: "PVP-CMC hydrogel: An excellent bioinspired and biocompatible scaffold for osseointegration",
      journal: "Materials Science and Engineering: C",
      year: "2019",
      volume: "95",
      pages: "440-449",
      impactFactor: "7.9",
      doi: "https://doi.org/10.1016/j.msec.2018.04.050",
      type: "Research Article"
    },
    {
      id: 80,
      authors: "Shreya Mehrotra, Joseph Christakiran Moses, Ashutosh Bandyopadhyay, Biman B. Mandal",
      title: "3D printing/bioprinting based tailoring of in vitro tissue models: Recent advances and challenges",
      journal: "ACS Applied Bio Materials",
      year: "2019",
      volume: "2",
      pages: "1385-1405",
      impactFactor: "4.7",
      doi: "https://doi.org/10.1021/acsabm.9b00073",
      type: "Review"
    },
    {
      id: 81,
      authors: "Shreya Mehrotra, Dimple Chouhan, Rocktotpal Konwarh, Manishekhar Kumar, Jadi Praveen Kumar, Biman B. Mandal",
      title: "A comprehensive review on silk at nanoscale for regenerative medicine and allied applications",
      journal: "ACS Biomaterials Science & Engineering",
      year: "2019",
      volume: "5",
      pages: "2054-2078",
      impactFactor: "5.5",
      doi: "https://doi.org/10.1021/acsbiomaterials.8b01560",
      type: "Review"
    },
    {
      id: 82,
      authors: "Piyali Das, Yogendra Pratap Singh, Siddhartha Narayan Joardar, Bikash Kanti Biswas, Rupnarayan Bhattacharya, Samit Kumar Nandi, Biman B. Mandal",
      title: "Decellularized Caprine Conchal Cartilage toward Repair and Regeneration of Damaged Cartilage",
      journal: "ACS Applied Bio Materials",
      year: "2019",
      volume: "2",
      pages: "2037-2049",
      impactFactor: "4.7",
      doi: "https://doi.org/10.1021/acsabm.9b00078",
      type: "Research Article"
    },
    {
      id: 83,
      authors: "Arpita Shome, Adil M Rather, Aindrila Ghosal, Bibhas K Bhunia, Biman B Mandal, Uttam Manna",
      title: "Rational Chemical Engineering in Natural Protein Derived Functional Interface",
      journal: "ACS Sustainable Chemistry & Engineering",
      year: "2019",
      volume: "7",
      pages: "7502-7509",
      impactFactor: "7.3",
      doi: "https://doi.org/10.1021/acssuschemeng.9b00501",
      type: "Research Article"
    },
    {
      id: 84,
      authors: "Praveen Kumar Jadi, Biman B Mandal",
      title: "Inhibitory Role of Silk Cocoon Extract on Elastase, Hyaluronidase and UV Radiation-Induced Matrix Metalloproteinases Expression in Human Dermal Fibroblast and Keratinocytes",
      journal: "Photochemical & Photobiological Sciences",
      year: "2019",
      volume: "18",
      pages: "1259-1274",
      impactFactor: "3.2",
      doi: "https://doi.org/10.1039/C8PP00524A",
      type: "Research Article"
    },
    {
      id: 85,
      authors: "Dimple Chouhan, Shreya Mehrotra, Omkar Majumder, Biman B. Mandal",
      title: "Magnetic actuator device assisted modulation of cellular behavior and tuning of drug release on silk platform",
      journal: "ACS Biomaterials Science & Engineering",
      year: "2019",
      volume: "5",
      pages: "92-105",
      impactFactor: "5.5",
      doi: "https://doi.org/10.1021/acsbiomaterials.8b00240",
      type: "Research Article"
    },
    {
      id: 86,
      authors: "Jadi Praveen Kumar, Biman B. Mandal",
      title: "Silk sericin induced pro-oxidative stress leads to apoptosis in human cancer cells",
      journal: "Food & Chemical Toxicology",
      year: "2019",
      volume: "123",
      pages: "275-287",
      impactFactor: "3.5",
      doi: "https://doi.org/10.1016/j.fct.2018.10.063",
      type: "Research Article"
    },
    {
      id: 87,
      authors: "Bibhas K. Bhunia, Biman B. Mandal",
      title: "Exploring gelation and physico-chemical behavior of in-situ bioresponsive silk hydrogels for disc degeneration therapy",
      journal: "ACS Biomaterials Science & Engineering",
      year: "2019",
      volume: "5",
      pages: "870-886",
      impactFactor: "5.5",
      doi: "https://doi.org/10.1021/acsbiomaterials.8b01099",
      type: "Research Article"
    },
    {
      id: 88,
      authors: "Prerak Gupta, Joseph Christakiran Moses, Biman B Mandal",
      title: "Surface patterning and innate physico-chemical attributes of silk films concomitantly govern vascular cell dynamics",
      journal: "ACS Biomaterials Science & Engineering",
      year: "2019",
      volume: "5",
      pages: "933-949",
      impactFactor: "5.5",
      doi: "https://doi.org/10.1021/acsbiomaterials.8b01194",
      type: "Research Article"
    },
    {
      id: 89,
      authors: "Khushwant Singh, Ankit Gangrade, Achintya Jana, Biman B. Mandal, Neeladri Das",
      title: "Design, synthesis, characterization and antiproliferative activity of organoplatinum compounds bearing 1,2,3-triazole ring",
      journal: "ACS Omega",
      year: "2019",
      volume: "4",
      pages: "835-841",
      impactFactor: "4.3",
      doi: "https://doi.org/10.1021/acsomega.8b02849",
      type: "Research Article"
    },
    {
      id: 187,
      authors: "Guru Janani, Shivanshi Kumar, Biman B. Mandal*",
      title: "Fiber-Reinforced Silk Composite for Enhanced Urokinase Production Using High-Density Perfusion Culture and Bioactive Molecule Supplementation",
      journal: "ACS Biomaterials Science & Engineering",
      year: "2019",
      volume: "5",
      pages: "6137-6151",
      impactFactor: "5.5",
      doi: "https://doi.org/10.1021/acsbiomaterials.9b01162",
      type: "Research Article"
    },
    {
      id: 188,
      authors: "Nandana Bhardwaj, Yogendra P. Singh, Biman B. Mandal*",
      title: "Silk fibroin scaffolds based 3D co-culture model for modulation of chondrogenesis without hypertrophy via reciprocal crosstalk and paracrine signaling",
      journal: "ACS Biomaterials Science & Engineering",
      year: "2019",
      volume: "5",
      pages: "5240-5254",
      impactFactor: "5.5",
      doi: "https://doi.org/10.1021/acsbiomaterials.9b00573",
      type: "Research Article"
    },
    {
      id: 189,
      authors: "Ashutosh Bandyopadhyay, Suvro Kanti Chowdhury, Souradeep Dey, Joseph Christakiran Moses and Biman B. Mandal*",
      title: "Silk – A promising biomaterial opening new vistas towards affordable healthcare solution",
      journal: "Journal of the Indian Institute of Science",
      year: "2019",
      pages: "1-43",
      impactFactor: "2.3",
      doi: "https://doi.org/10.1007/s41745-019-00114-y",
      type: "Review"
    },
    {
      id: 190,
      authors: "Jadi Praveen Kumar and Biman B. Mandal*",
      title: "The Inhibitory Effect of Silk Sericin against Ultraviolet-induced Melanogenesis and Its Potential use in Cosmeceutics as an Anti-Hyperpigmentation Compound",
      journal: "Photochemical & Photobiological Sciences",
      year: "2019",
      volume: "18",
      pages: "2497-2508",
      impactFactor: "3.2",
      doi: "https://doi.org/10.1039/c9pp00059c",
      type: "Research Article"
    },
    {
      id: 191,
      authors: "Bruna A. G. de Melo, Yasamin A. Jodat, Shreya Mehrotra, Michelle A. Calabrese, Tom Kamperman, Biman B. Mandal, Maria H. A. Santana, Eben Alsberg, Jeroen Leijten, Su Ryon Shin",
      title: "3D Printed Cartilage-like Tissue Constructs with Spatially Controlled Mechanical Properties",
      journal: "Advanced Functional Materials",
      year: "2019",
      volume: "29",
      pages: "1906330",
      impactFactor: "19.0",
      doi: "https://doi.org/10.1002/adfm.201906330",
      type: "Research Article"
    },
    {
      id: 192,
      authors: "Yogendra P. Singh, Ashutosh Bandyopadhyay, Biman B. Mandal*",
      title: "3D Bioprinting using Cross-Linker Free Silk-Gelatin Bioink for Cartilage Tissue Engineering",
      journal: "ACS Applied Materials & Interfaces",
      year: "2019",
      volume: "11",
      pages: "33684-33696",
      impactFactor: "8.2",
      doi: "https://doi.org/10.1021/acsami.9b11644",
      type: "Research Article"
    },
    {
      id: 193,
      authors: "Junmin Lee, Vijayan Manoharan, Louis CheungΓ, Seungkyu Lee, Byung-Hyun Cha, Peter Newman, Razieh Farzad, Shreya Mehrotra, Kaizhen Zhang, Fazal Khan, Masoumeh Ghaderi, Yi-Dong Lin, Saira Aftab, Pooria Mostafalu, Mario Miscuglio, Joan Li, Biman B. Mandal, Mohammad Asif Hussain, Kai-tak Wan, Xiaowu (Shirley) Tang, Ali Khademhosseini, Su Ryon Shin",
      title: "Nanoparticle-based hybrid scaffolds for deciphering the role of multi-modal cues in cardiac tissue engineering",
      journal: "ACS Nano",
      year: "2019",
      volume: "13",
      pages: "12525-12539",
      impactFactor: "16.0",
      doi: "https://doi.org/10.1021/acsnano.9b03050",
      type: "Research Article"
    },
  ],
  "2018": [
    {
      id: 90,
      authors: "Bibhas K. Bhunia, David Kaplan, Biman B Mandal",
      title: "Silk-based multilayered angle-ply annulus fibrosus construct to recapitulate form and function of the intervertebral disc",
      journal: "PNAS",
      year: "2018",
      volume: "115",
      pages: "477-482",
      impactFactor: "9.1",
      doi: "https://doi.org/10.1073/pnas.1715912115",
      type: "Research Article"
    },
    {
      id: 91,
      authors: "Manishekhar Kumar, Prerak Gupta, Sohenii Bhattacharjee, Samit K. Nandi, Biman B. Mandal",
      title: "Immunomodulatory injectable silk hydrogels maintaining functional islets and promoting anti-inflammatory M2 macrophage polarization",
      journal: "Biomaterials",
      year: "2018",
      volume: "187",
      pages: "1-17",
      impactFactor: "12.9",
      doi: "https://doi.org/10.1016/j.biomaterials.2018.09.037",
      type: "Research Article"
    },
    {
      id: 92,
      authors: "Dimple Chouhan, Tshewuzo-u Lohe, Pavan Kumar Samudrala, Biman B. Mandal",
      title: "In situ forming silk fibroin hydrogel promotes skin regeneration in full thickness burn wounds",
      journal: "Advanced Healthcare Materials",
      year: "2018",
      volume: "7",
      pages: "e1801092",
      impactFactor: "9.6",
      doi: "https://doi.org/10.1002/adhm.201801092",
      type: "Research Article"
    },
    {
      id: 93,
      authors: "Dimple Chouhan, Naresh Thatikonda, Linnea Nilebäck, Mona Widhe, My Hedhammar, Biman B. Mandal",
      title: "Recombinant spider silk functionalized silkworm silk matrices as potential bioactive wound dressings and skin grafts",
      journal: "ACS Applied Materials and Interfaces",
      year: "2018",
      volume: "10",
      pages: "23560-23572",
      impactFactor: "8.2",
      doi: "https://doi.org/10.1021/acsami.8b05853",
      type: "Research Article"
    },
    {
      id: 94,
      authors: "Joseph Christakiran Moses, Samit K. Nandi, Biman B Mandal",
      title: "Multifunctional cell instructive silk-bioactive glass composite reinforced scaffolds towards osteoinductive, proangiogenic and resorbable bone grafts",
      journal: "Advanced Healthcare Materials",
      year: "2018",
      volume: "7",
      pages: "e1701418",
      impactFactor: "9.6",
      doi: "https://doi.org/10.1002/adhm.201701418",
      type: "Research Article"
    },
    {
      id: 95,
      authors: "Yogendra Pratap Singh, Joseph Christakiran Moses, Bibhas K. Bhunia, Samit K. Nandi, Biman B. Mandal",
      title: "Hierarchically structured seamless silk scaffolds for osteochondral interface tissue engineering",
      journal: "Journal of Materials Chemistry B",
      year: "2018",
      volume: "6",
      pages: "5671-5688",
      impactFactor: "5.7",
      doi: "https://doi.org/10.1039/C8TB01344F",
      type: "Research Article"
    },
    {
      id: 96,
      authors: "Adil Rather, Arpita Shome, Suresh Kumar, Bibhas K. Bhunia, Biman B Mandal, Hemant Srivastava, Uttam Manna",
      title: "Alkali Metal-ion Assisted Michael Addition Reaction in Controlled Tailoring of Topography in Superhydrophobic Polymeric Monolith",
      journal: "Journal of Materials Chemistry A",
      year: "2018",
      volume: "6",
      pages: "17019-17031",
      impactFactor: "9.5",
      doi: "https://doi.org/10.1039/C8TA06329J",
      type: "Research Article"
    },
    {
      id: 97,
      authors: "Bibhas K. Bhunia, Biman B. Mandal",
      title: "Modulation of extracellular matrix by annulus fibrosus cells on tailored silk based angle-ply intervertebral disc construct",
      journal: "Materials and Design",
      year: "2018",
      volume: "158",
      pages: "74-87",
      impactFactor: "7.9",
      doi: "https://doi.org/10.1016/j.matdes.2018.08.015",
      type: "Research Article"
    },
    {
      id: 98,
      authors: "Dimple Chouhan, Janani Guru, Bijayashree Chakraborty, Samit Nandi, Biman B Mandal",
      title: "Functionalized PVA-Silk blended nanofibrous mats promote diabetic wound healing via regulation of extracellular matrix and tissue remodeling",
      journal: "Journal of Tissue Engineering and Regenerative Medicine",
      year: "2018",
      volume: "12",
      pages: "e1559-1570",
      impactFactor: "2.6",
      doi: "https://doi.org/10.1002/term.2581",
      type: "Research Article"
    },
    {
      id: 99,
      authors: "Sudesna Chakravarty, Bedanta Gogoi, Biman B Mandal, Nandana Bhardwaj, Neelotpal Sen Sarma",
      title: "Silk fibroin as a platform for dual sensing of vitamin B12 using photoluminescence and electrical techniques",
      journal: "Biosensors and Bioelectronics",
      year: "2018",
      volume: "112",
      pages: "18-22",
      impactFactor: "10.5",
      doi: "https://doi.org/10.1016/j.bios.2018.03.057",
      type: "Research Article"
    },
    {
      id: 100,
      authors: "Yogendra Pratap Singh, Joseph Christakiran Moses, Nandana Bhardwaj, Biman B. Mandal",
      title: "Injectable hydrogels: a new paradigm for osteochondral tissue engineering",
      journal: "Journal of Materials Chemistry B",
      year: "2018",
      volume: "6",
      pages: "5499-5529",
      impactFactor: "7.0",
      doi: "https://doi.org/10.1039/C8TB01430B",
      type: "Review"
    },
    {
      id: 101,
      authors: "Jadi Praveen Kumar, Shamshad Alam, Abhishek Jain, Kausar Ansari, Biman B. Mandal",
      title: "Protective activity of silk sericin against UV radiation-induced skin damage by downregulating oxidative stress",
      journal: "ACS Applied Bio Materials",
      year: "2018",
      volume: "1",
      pages: "2120–2132",
      impactFactor: "4.7",
      doi: "https://doi.org/10.1021/acsabm.8b00558",
      type: "Research Article"
    },
    {
      id: 102,
      authors: "Adil M. Rather, Arpita Shome, Bibhas K. Bhunia, Aparna Panuganti, Biman B Mandal, Uttam Manna",
      title: "Simultaneous and controlled release of two different bioactive small molecules from nature inspired single material",
      journal: "Journal of Materials Chemistry B",
      year: "2018",
      volume: "6",
      pages: "7692-7702",
      impactFactor: "5.7",
      doi: "https://doi.org/10.1039/C8TB02406E",
      type: "Research Article"
    },
    {
      id: 103,
      authors: "Saundray Raj Soni, Nimmy Kumari, Bibhas K. Bhunia, Biswatrish Sarkar, Biman B. Mandal, Animesh Ghosh",
      title: "In vitro and in vivo evaluation of pirfenidone loaded acrylamide grafted pullulan-poly(vinyl alcohol) interpenetrating polymer networks",
      journal: "Carbohydrate Polymers",
      year: "2018",
      volume: "202",
      pages: "288-298",
      impactFactor: "12.5",
      doi: "https://doi.org/10.1016/j.carbpol.2018.08.135",
      type: "Research Article"
    },
    {
      id: 104,
      authors: "Saundray Raj Soni, Bibhas Bhunia, Nimmy Kumari, Subhashis Dan, Sudipta Mukherjee, Biman B. Mandal, Animesh Ghosh",
      title: "Therapeutically effective controlled release formulation of pirfenidone from non-toxic biocompatible carboxymethyl pullulan-poly(vinyl alcohol) interpenetrating polymer networks",
      journal: "ACS Omega",
      year: "2018",
      volume: "3",
      pages: "11993–12009",
      impactFactor: "4.3",
      doi: "https://doi.org/10.1021/acsomega.8b00803",
      type: "Research Article"
    },
    {
      id: 105,
      authors: "Saundray Raj Soni, Nimmy Kumari, Bibhas K. Bhunia, Biswatrish Sarkar, Biman B. Mandal, Animesh Ghosh",
      title: "Synthesis and characterization of a non-cytotoxic and biocompatible acrylamide grafted pullulan – Application in pH responsive controlled drug delivery",
      journal: "International Journal of Biological Macromolecules",
      year: "2018",
      volume: "120",
      pages: "753-762",
      impactFactor: "8.5",
      doi: "https://doi.org/10.1016/j.ijbiomac.2018.08.123",
      type: "Research Article"
    },
    {
      id: 106,
      authors: "Sourav Bhowmick, Achintya Jana, Khushwant Singh, Prerak Gupta, Ankit Gangrade, Biman B. Mandal, Neeladri Das",
      title: "Coordination driven Self-assembly of Ionic Irregular Hexagonal Metallamacrocycles via an Organometallic Clip and their Cytotoxicity Potency",
      journal: "Inorganic Chemistry",
      year: "2018",
      volume: "57",
      pages: "3615–3625",
      impactFactor: "4.7",
      doi: "https://doi.org/10.1021/acs.inorgchem.7b01561",
      type: "Research Article"
    },
    {
      id: 107,
      authors: "Rana Dalapati, Soutick Nandi, Helge Reinsch, Bibhas K. Bhunia, Biman B Mandal, Norbert Stock, Shyam Biswas",
      title: "Fluorogenic naked-eye sensing and live-cell imaging of cyanide by hydrazine-functionalized CAU-10 metal-organic framework",
      journal: "CrystEngComm",
      year: "2018",
      volume: "20",
      pages: "4194-4201",
      impactFactor: "2.6",
      doi: "https://doi.org/10.1039/C8CE00818C",
      type: "Research Article"
    },
    {
      id: 108,
      authors: "Sween Gilotra, Dimple Chouhan, Nandana Bhardwaj, Samit K. Nandi, Biman B. Mandal",
      title: "Potential of silk sericin based nanofibrous mats for wound dressing applications",
      journal: "Materials Science and Engineering C",
      year: "2018",
      volume: "90",
      pages: "420-432",
      impactFactor: "7.9",
      doi: "https://doi.org/0.1016/j.msec.2018.04.077",
      type: "Research Article"
    },
    {
      id: 109,
      authors: "Ashish A. Prabhu, Anwesha Purkayastha, Bapi Mandal, Jadi Praveen Kumar, Biman B Mandal, Venkata Dasu Veeranki",
      title: "A novel reverse micellar purification strategy for histidine tagged human interferon gamma (hIFN-γ) protein from Pichia pastoris",
      journal: "International Journal Biological Macromolecules",
      year: "2018",
      volume: "107",
      pages: "2512-2524",
      impactFactor: "8.5",
      doi: "https://doi.org/10.1016/j.ijbiomac.2017.10.130",
      type: "Research Article"
    },
    {
      id: 110,
      authors: "Rituparna Duarah, Yogendra Pratap Singh, Prerak Gupta, Biman B. Mandal, Niranjan Karak",
      title: "Smart self tightening surgical suture from tough bio-based hyperbranched polyurethane/reduced carbon dot nanocomposite",
      journal: "Biomedical Materials",
      year: "2018",
      volume: "13",
      pages: "045004",
      impactFactor: "3.7",
      doi: "https://doi.org/10.1088/1748-605X/aab93c",
      type: "Research Article"
    },
    {
      id: 111,
      authors: "Khushwant Singh, Ankit Gangrade, Sourav Bhowmick, Achintya Jana, Biman B. Mandal, Neeladri Das",
      title: "Self-assembly of a [1+1] ionic hexagonal macrocycle and its antiproliferative activity",
      journal: "Frontiers in Chemistry",
      year: "2018",
      volume: "6",
      pages: "87",
      impactFactor: "4.2",
      doi: "https://doi.org/10.3389/fchem.2018.00087",
      type: "Research Article"
    }
  ],
  "2017": [
    {
      id: 112,
      authors: "Avijit Das, Jumi Deka, Adil Rather, Bibhas K. Bhunia, Partha Saikia, Biman B. Mandal, Kalyan Raidongia, Uttam Manna",
      title: "Strategic Formulation of graphene oxide sheets for flexible monoliths and robust polymeric coatings that embedded with durable bio-inspired wettability",
      journal: "ACS Applied Materials and Interfaces",
      year: "2017",
      volume: "9",
      pages: "42354-42365",
      impactFactor: "8.2",
      doi: "https://doi.org/10.1021/acsami.7b14028",
      type: "Research Article"
    },
    {
      id: 113,
      authors: "Prerak Gupta, Biman B Mandal",
      title: "Osteoinductive and proangiogenic bioactive glass silk composite scaffolds towards resorbable and vascularized bone grafts",
      journal: "Tissue Engineering Part A",
      year: "2017",
      volume: "23",
      pages: "S89-S89",
      impactFactor: "2.9",
      type: "Research Article"
    },
    {
      id: 114,
      authors: "Manishekhar Kumar, Samit Nandi, David Kaplan, Biman B Mandal",
      title: "Localized immunomodulatory silk macrocapsules for islet-like spheroid formation and sustained insulin production",
      journal: "ACS Biomaterials Science & Engineering",
      year: "2017",
      volume: "3",
      pages: "2443-2456",
      impactFactor: "5.5",
      doi: "https://doi.org/10.1021/acsbiomaterials.7b00218",
      type: "Research Article"
    },
    {
      id: 115,
      authors: "Yogendra Pratap Singh, Mimi Adhikary, Nandana Bhardwaj, Bibhas K. Bhunia, Shreya Mehrotra, Biman B Mandal",
      title: "Bioinspired three dimensional construct with silk fiber reinforcement for regeneration of load bearing soft tissues",
      journal: "Tissue Engineering Part A",
      year: "2017",
      volume: "23",
      pages: "S102-S102",
      impactFactor: "2.9",
      doi: "https://doi.org/10.1089/ten.tea.2017.29003",
      type: "Research Article"
    },
    {
      id: 116,
      authors: "Shreya Mehrotra, Samit Kumar Nandi, Biman B Mandal",
      title: "Stacked silk-cell monolayers as a biomimetic three dimensional construct for cardiac tissue reconstruction",
      journal: "Journal of Materials Chemistry B",
      year: "2017",
      volume: "5",
      pages: "6325-6338",
      impactFactor: "5.7",
      doi: "https://doi.org/10.1039/C7TB01494E",
      type: "Research Article"
    },
    {
      id: 117,
      authors: "Yogendra Pratap Singh, Mimi Adhikary, Nandana Bhardwaj, Bibhas K. Bhunia, Biman B. Mandal",
      title: "Silk fiber reinforcement modulates in vitro chondrogenesis in 3D composite scaffolds",
      journal: "Biomedical Materials",
      year: "2017",
      volume: "12",
      pages: "045012",
      impactFactor: "3.7",
      doi: "https://doi.org/10.1088/1748-605X/aa7697",
      type: "Research Article"
    },
    {
      id: 118,
      authors: "Joseph Christakiran Moses, Philip J.T. Reardon, Rocktotpal Konwarh, Jonathan C. Knowles, Biman B Mandal",
      title: "Mimicking hierarchical complexity of the osteochondral interface using electrospun silk-bioactive glass composites",
      journal: "ACS Applied Materials and Interfaces",
      year: "2017",
      volume: "9",
      pages: "8000-8013",
      impactFactor: "8.2",
      doi: "https://doi.org/10.1021/acsami.6b16590",
      type: "Research Article"
    },
    {
      id: 119,
      authors: "Jadi Praveen Kumar, Biman B. Mandal",
      title: "Antioxidant potential of mulberry and non-mulberry silk sericin and its implications in biomedicine",
      journal: "Free Radical Biology and Medicine",
      year: "2017",
      volume: "108",
      pages: "803-818",
      impactFactor: "8.2",
      doi: "https://doi.org/10.1016/j.freeradbiomed.2017.05.002",
      type: "Research Article"
    },
    {
      id: 120,
      authors: "Shreya Mehrotra, Biman B Mandal",
      title: "In vitro fabrication of functional anisotropic 3D constructs using silk-cardiomyocyte monolayers",
      journal: "Tissue Engineering Part A",
      year: "2017",
      volume: "23",
      pages: "S61-S62",
      impactFactor: "2.9",
      doi: "https://doi.org/10.1089/ten.tea.2017.29003.1",
      type: "Research Article"
    },
    {
      id: 121,
      authors: "Nandana Bhardwaj, Dimple Chouhan, Biman B. Mandal",
      title: "Tissue engineered skin and wound healing: current strategies and future directions",
      journal: "Current Pharmaceutical Design",
      year: "2017",
      volume: "23",
      pages: "3455-3482",
      impactFactor: "2.8",
      doi: "https://doi.org/10.2174/1381612823666170526094606",
      type: "Review"
    },
    {
      id: 122,
      authors: "Dimple Chouhan, Bijayshree Chakraborty, Samit K. Nandi, Biman B. Mandal",
      title: "Role of non-mulberry silk fibroin in deposition and regulation of extracellular matrix towards accelerated wound healing",
      journal: "Acta Biomaterialia",
      year: "2017",
      volume: "48",
      pages: "157-174",
      impactFactor: "9.6",
      doi: "https://doi.org/10.1016/j.actbio.2016.10.019",
      type: "Research Article"
    },
    {
      id: 123,
      authors: "Manishekhar Kumar, Samit K. Nandi, David L. Kaplan, Biman B. Mandal",
      title: "Immunomodulatory bioartificial pancreas for sustained insulin production in diabetic patients",
      journal: "European Cells & Materials",
      year: "2017",
      volume: "33",
      pages: "Suppl. 2, 0323",
      impactFactor: "3.1",
      type: "Research Article"
    },
    {
      id: 124,
      authors: "Prerak Gupta, Biman B Mandal",
      title: "Surface topography of silk films influences the functional behavior of vascular cells",
      journal: "Tissue Engineering Part A",
      year: "2017",
      volume: "23",
      pages: "S57-S57",
      impactFactor: "2.9",
      type: "Research Article"
    },
    {
      id: 125,
      authors: "Bibhas K. Bhunia, Manishekhar Kumar, Biman B. Mandal",
      title: "Development of silk based angle-ply construct for annulus fibrosus tissue engineering",
      journal: "European Cells and Materials",
      year: "2017",
      volume: "33",
      pages: "Suppl. 2, P425",
      impactFactor: "3.1",
      type: "Research Article"
    },
    {
      id: 126,
      authors: "Santosh Kumar Behera, Anwesha Murkherjee, G. Sadhuragiri, Palani Elumalai, M. Sathiyendiran, Manishekhar Kumar, Biman B. Mandal, G. Krishnamoorthy",
      title: "Aggregation induced enhanced and exclusive highly stoke shifted emission from an excited state intramolecular proton transfer exhibiting molecule",
      journal: "Faraday Discussions",
      year: "2017",
      volume: "196",
      pages: "71-90",
      impactFactor: "3.1",
      doi: "https://doi.org/10.1039/C6FD00171H",
      type: "Research Article"
    },
    {
      id: 127,
      authors: "Rocktotpal Konwarh, Bibhas K. Bhunia, Biman B. Mandal",
      title: "Opportunities and challenges in exploring indian nonmulberry silk for biomedical application",
      journal: "Procedings of the Indian National Science Academy",
      year: "2017",
      volume: "83",
      pages: "85-101",
      impactFactor: "2.1",
      doi: "https://doi.org/10.16943/ptinsa/2017/41288",
      type: "Research Article"
    }
  ],
  "2016": [
    {
      id: 128,
      authors: "Saket K. Singh, Bibhas K. Bhunia, Nandana Bhardwaj, Sween Gilotra, Biman B. Mandal",
      title: "Reloadable silk-hydrogel hybrid scaffolds for sustained and targeted delivery of molecules",
      journal: "Molecular Pharmaceutics",
      year: "2016",
      volume: "13",
      pages: "4066-4081",
      impactFactor: "4.5",
      doi: "https://doi.org/10.1021/acs.molpharmaceut.6b00672",
      type: "Research Article"
    },
    {
      id: 129,
      authors: "Jadi Praveen Kumar, Nandana Bhardwaj, Biman B. Mandal",
      title: "Cross-linked silk sericin-gelatin 2d and 3d matrices for prospective tissue engineering application",
      journal: "RSC Advances",
      year: "2016",
      volume: "6",
      pages: "105125-105136",
      impactFactor: "4.6",
      doi: "https://doi.org/10.1039/C6RA18654H",
      type: "Research Article"
    },
    {
      id: 130,
      authors: "Yogendra Pratap Singh, Nandana Bhardwaj, Biman B. Mandal",
      title: "Potential of agarose/silk fibroin blended hydrogel for in vitro cartilage tissue engineering",
      journal: "ACS Applied Materials and Interfaces",
      year: "2016",
      volume: "8",
      pages: "21236–21249",
      impactFactor: "8.2",
      doi: "https://doi.org/10.1021/acsami.6b08285",
      type: "Research Article"
    },
    {
      id: 131,
      authors: "Prerak Gupta, Manishekhar Kumar, Nandana Bhardwaj, Jadi Praveen Kumar, C. S. Krishnamurthy, Samit K. Nandi, Biman B. Mandal",
      title: "Mimicking form and function of native small diameter vascular conduits using mulberry and non-mulberry pattered silk films",
      journal: "ACS Applied Materials and Interfaces",
      year: "2016",
      volume: "8",
      pages: "15874-15888",
      impactFactor: "8.2",
      doi: "https://doi.org/10.1021/acsami.6b00783",
      type: "Research Article"
    },
    {
      id: 132,
      authors: "Rocktotpal Konwarh, Prerak Gupta, Biman B. Mandal",
      title: "Silk Microfluidics for advanced biotechnological applications: A progressive review",
      journal: "Biotechnology Advances",
      year: "2016",
      volume: "34",
      pages: "845-58",
      impactFactor: "12.5",
      doi: "https://doi.org/10.1016/j.biotechadv.2016.05.001",
      type: "Review"
    },
    {
      id: 133,
      authors: "Prerak Gupta, Mimi Adhikary, Joseph Christakiran Moses, Manishekhar Kumar, Nandana Bhardwaj, Biman B. Mandal",
      title: "Biomimetic, osteoconductive non-mulberry silk fiber reinforced tricomposite scaffolds for bone tissue engineering",
      journal: "ACS Applied Materials and Interfaces",
      year: "2016",
      volume: "8",
      pages: "30797-30810",
      impactFactor: "8.2",
      doi: "https://doi.org/10.1021/acsami.6b11366",
      type: "Research Article"
    },
    {
      id: 134,
      authors: "Manishekhar Kumar, Jeannin M Coburn, David L. Kaplan, Biman B. Mandal",
      title: "Immuno-informed 3D silk-biomaterials for tailoring biological responses",
      journal: "ACS Applied Materials and Interfaces",
      year: "2016",
      volume: "8",
      pages: "29310-29322",
      impactFactor: "9.5",
      doi: "https://doi.org/10.1021/acsami.6b09937",
      type: "Research Article"
    },
    {
      id: 135,
      authors: "Ali D. Malay, Kenjiro Yazawa, Hiroe Watanabe, Ryota Sato, Nao Ifuku, Hiroyasu Masunaga, Takaaki Hikima, Juan Guan, Biman B. Mandal, Siriporn Damrongsakkul, Keiji Numata",
      title: "Relationships between physical properties and sequence in silkworm silks",
      journal: "Scientific Reports",
      year: "2016",
      volume: "6",
      pages: "27573",
      impactFactor: "3.9",
      doi: "https://doi.org/10.1038/srep27573",
      type: "Research Article"
    },
    {
      id: 136,
      authors: "Nandana Bhardwaj, Yogendra Pratap Singh, Dipali Devi, Raghuram Kandimalla, Jibon Kotoky, Biman B. Mandal",
      title: "Potential of silk fibroin/chondrocyte constructs of muga silkworm Antheraea assamensis for cartilage tissue engineering",
      journal: "Journal of Materials Chemistry B",
      year: "2016",
      volume: "4",
      pages: "3670-3684",
      impactFactor: "5.7",
      doi: "https://doi.org/10.1039/C6TB00717A",
      type: "Research Article"
    },
    {
      id: 137,
      authors: "Sudesna Chakravarty, Nandana Bhardwaj, Biman B. Mandal, Neelotpal Sensarma",
      title: "Silk Fibroin-Carbon Nanoparticle composite Scaffolds: A cost effective supramolecular ‘turn off’ chemiresistor for nitro aromatic explosive vapours",
      journal: "Journal of Materials Chemistry C",
      year: "2016",
      volume: "4",
      pages: "8920-8929",
      impactFactor: "5.1",
      doi: "https://doi.org/10.1039/C6TC03337G",
      type: "Research Article"
    },
    {
      id: 138,
      authors: "Rituparna Duarah, Yogendra P Singh, Prerak Gupta, Biman B Mandal, Niranjan Karak",
      title: "High performance bio-based hyperbranched polyurethane/carbon dot-silver nanocomposite: A rapid self-expandable stent",
      journal: "Biofabrication",
      year: "2016",
      volume: "8",
      pages: "045013",
      impactFactor: "8.0",
      doi: "https://doi.org/10.1088/1758-5090/8/4/045013",
      type: "Research Article"
    },
    {
      id: 139,
      authors: "Lakshminath Kundanati, Saket Kumar, Biman B. Mandal, Tejas G Murthy, Namrata Gundiah, Nicola M. Pugno",
      title: "Fabrication and mechanical characterization of hydrogel infused network silk scaffolds for tissue engineering",
      journal: "International Journal of Molecular Sciences",
      year: "2016",
      volume: "17",
      pages: "1631",
      impactFactor: "4.9",
      doi: "https://doi.org/10.3390/ijms17101631",
      type: "Research Article"
    },
    {
      id: 140,
      authors: "Manishekhar Kumar, Deepak Jain, Nandana Bhardwaj, Prerak Gupta, Samit K. Nandi, Biman B. Mandal",
      title: "Native honeybee silk membrane: A potential matrix for tissue engineering and regenerative medicine",
      journal: "RSC Advances",
      year: "2016",
      volume: "6",
      pages: "54394-54403",
      impactFactor: "4.6",
      doi: "https://doi.org/10.1039/C6RA10738A",
      type: "Research Article"
    },
    {
      id: 141,
      authors: "Mimi Adhikary, Prerak Gupta, Manishekhar Kumar, Salma Jasmine, Nandana Bhardwaj, Dimple Chouhan, Biman B. Mandal",
      title: "Hydroxyapatite-silk fiber-silk fibroin tri-composite scaffolds for bone tissue engineering",
      journal: "European Cells & Materials",
      year: "2016",
      volume: "31",
      pages: "18",
      impactFactor: "3.1",
      type: "Research Article"
    },
    {
      id: 142,
      authors: "Dimple Chauhan, Samit K. Nandi, Biman B. Mandal",
      title: "Non-mulberry silk fibroin based smart nanofibrous wound dressing for chronic cutaneous ulcers",
      journal: "European Cells & Materials",
      year: "2016",
      volume: "31",
      pages: "239",
      impactFactor: "3.1",
      type: "Research Article"
    },
    {
      id: 143,
      authors: "Ashim Malakar, Himadree Tanaya Biswal, K. Anki Reddy, Manishekhar Kumar, Biman B. Mandal, G. Krishnamoorthy",
      title: "Aggregation induced enhanced emission of 2-(2′-hydroxyphenyl) benzimidazole: a combined experimental and simulation approach",
      journal: "Photochemical and Photobiological Sciences",
      year: "2016",
      volume: "15",
      pages: "937-48",
      impactFactor: "3.2",
      doi: "https://doi.org/10.1039/c6pp00122j",
      type: "Research Article"
    },
    {
      id: 144,
      authors: "Nisha Shankhwar, Manishekhar Kumar, Biman B. Mandal, A. Srinivasan",
      title: "Novel polyvinyl alcohol-bioglass 45S5 based composite nanofibrous membranes as bone scaffolds",
      journal: "Materials Science and Engineering: C",
      year: "2016",
      volume: "69",
      pages: "1167-74",
      impactFactor: "6.0",
      doi: "https://doi.org/10.1016/j.msec.2016.08.018",
      type: "Research Article"
    },
    {
      id: 145,
      authors: "Yogendra Pratap Singh, Joseph Christakiran Moses, Bibhas K. Bhunia, Biman B Mandal",
      title: "Bi-phasic silk scaffolds for osteochondral tissue engineering",
      journal: "European Cells & Materials",
      year: "2016",
      volume: "31",
      pages: "326",
      impactFactor: "3.1",
      type: "Research Article"
    },
    {
      id: 146,
      authors: "Rituparna Duarah, Yogendra Pratap Singh, Biman B. Mandal, Niranjan Karak",
      title: "Sustainable starch modified polyol based tough biocompatible hyperbranched polyurethane with shape memory attribute",
      journal: "New Journal of Chemistry",
      year: "2016",
      volume: "40",
      pages: "5152-5163",
      impactFactor: "2.5",
      doi: "https://doi.org/10.1039/C5NJ03294F",
      type: "Research Article"
    },
    {
      id: 147,
      authors: "Satyabrat Gogoi, Manishekhar Kumar, Biman B. Mandal, Niranjan Karak",
      title: "A renewable resource based carbon dot decorated hydroxyapatite nanohybrid and its fabrication with waterborne hyperbranched polyurethane for bone tissue engineering",
      journal: "RSC Advances",
      year: "2016",
      volume: "6",
      pages: "26066-26076",
      impactFactor: "4.6",
      doi: "https://doi.org/10.1039/C6RA02341J",
      type: "Research Article"
    },
    {
      id: 148,
      authors: "Prerak Gupta, Manishekhar Kumar, Nandana Bhardwaj, Jadi Praveen Kumar, C. S. Krishnamurthy, Samit K. Nandi, Biman B. Mandal",
      title: "Bioengineered silk vascular grafts for coronary artery bypass surgery",
      journal: "European Cells & Materials",
      year: "2016",
      volume: "31",
      pages: "231",
      impactFactor: "3.1",
      type: "Research Article"
    },
    {
      id: 149,
      authors: "Nisha Shankhwar, Manishekhar Kumar, Biman B. Mandal, P.S. Robi, A. Srinivasan",
      title: "Electrospun polyvinyl alcohol-polyvinyl pyrrolidone nanofibrous membranes for interactive wound dressing applications",
      journal: "Journal of Biomaterials Science, Polymer Edition",
      year: "2016",
      volume: "27",
      pages: "247-262",
      impactFactor: "3.6",
      doi: "https://doi.org/10.1080/09205063.2015.1120474",
      type: "Research Article"
    },
  ],
  "2013":[
    {
      id: 150,
      authors: "Bibekananda De, Manishekhar Kumar, Biman B. Mandal, Niranjan Karak",
      title: "An in situ prepared photo-luminescent transparent biocompatible hyperbranched epoxy/carbon dot nanocomposite",
      journal: "RSC Advances",
      year: "2015",
      volume: "5",
      pages: "74692-74704",
      impactFactor: "4.6",
      doi: "https://doi.org/10.1039/C5RA12131K",
      type: "Research Article"
    },
    {
      id: 151,
      authors: "Satyabrat Gogoi, Manishekhar Kumar, Biman B. Mandal, Niranjan Karak",
      title: "High performance luminescent thermosetting waterborne hyperbranched polyurathane/carbon quantum dot nanocomposite with in vitro cytocompatibility",
      journal: "Composites Science & Technology",
      year: "2015",
      volume: "118",
      pages: "39-46",
      impactFactor: "9.8",
      doi: "https://doi.org/10.1016/j.compscitech.2015.08.010",
      type: "Research Article"
    },
    {
      id: 152,
      authors: "Nandana Bhardwaj, Dipali Devi, Biman B Mandal",
      title: "Tissue-engineered cartilage: the crossroads of biomaterials, cells and stimulating factors",
      journal: "Macromolecular Bioscience",
      year: "2015",
      volume: "15",
      pages: "153-182",
      impactFactor: "4.1",
      doi: "https://doi.org/10.1002/mabi.201400335",
      type: "Review"
    },
    {
      id: 153,
      authors: "Nandana Bhardwaj, Wan Ting Sow, Diplai Devi, Kee Woei Ng, Biman B. Mandal, Nam-Joon Cho",
      title: "Silk fibroin-keratin based 3D scaffolds as a dermal substitute for skin tissue engineering",
      journal: "Integrative Biology",
      year: "2015",
      volume: "7",
      pages: "53-63",
      impactFactor: "1.4",
      doi: "https://doi.org/10.1039/c4ib00208c",
      type: "Research Article"
    },
    {
      id: 154,
      authors: "Samit K. Nandi, Biswanath Kundu, Arnab Mahato, Narsinh L Thakur, Siddhartha Joardar, Biman B. Mandal",
      title: "In Vitro and in vivo evaluation of natural marine sponge skeleton as a bone mimicking biomaterial",
      journal: "Integrative Biology",
      year: "2015",
      volume: "7",
      pages: "250-262",
      impactFactor: "1.4",
      doi: "https://doi.org/10.1039/c4ib00289j",
      type: "Research Article"
    },
    {
      id: 155,
      authors: "Manishekhar Kumar, Biman B. Mandal",
      title: "Silk-based macro encapsulates for sustained insulin release",
      journal: "Tissue Engineering Part A",
      year: "2015",
      volume: "21",
      pages: "S65-S66",
      impactFactor: "2.9",
      type: "Research Article"
    },
    {
      id: 156,
      authors: "Supansa Yodmuang, Stephanie L. McNamara, Adam B. Nover, Biman B. Mandal, Monica Agarwal, Terri-Ann N. Kelly, Pen-hsiu Grace Chao, Clark Hung, David L. Kaplan, Gordana Vunjak-Novakovic",
      title: "Silk microfiber-reinforced silk hydrogel composite for functional cartilage tissue repair",
      journal: "Acta Biomaterialia",
      year: "2015",
      volume: "11",
      pages: "27-36",
      impactFactor: "9.6",
      doi: "https://doi.org/10.1016/j.actbio.2014.09.032",
      type: "Research Article"
    },
    {
      id: 159,
      authors: "Biman B. Mandal, Eun Seok Gil, Bruce Panilaitis, David L. Kaplan",
      title: "Laminar silk scaffolds for aligned tissue fabrication",
      journal: "Macromolecular Bioscience",
      year: "2013",
      volume: "13",
      pages: "48-58",
      impactFactor: "4.1",
      doi: "https://doi.org/10.1002/mabi.201200230",
      type: "Research Article"
    },
  ],
  "2014":[
    {
      id: 157,
      authors: "Nihar Dash, Ashim Malakar, Manishekhar Kumar, Biman B. Mandal, G. Krishnamoorthy",
      title: "Metal ion dependent “ON” intramolecular charge transfer (ICT) and “OFF” normal switching of the fluorescence: Sensing of ZN2+ by ICT emission in living cells",
      journal: "Sensors and Actuators B: Chemical",
      year: "2014",
      volume: "202",
      pages: "1154-1163",
      impactFactor: "7.7",
      doi: "https://doi.org/10.1016/j.snb.2014.06.047",
      type: "Research Article"
    },
    {
      id: 158,
      authors: "S. Barkam, J. Ortiz, R. McCormack, Biman B. Mandal, S Das, S Seal",
      title: "Protein integrated ceria-PLGA bioactive 3D scaffold for tissue regeneration",
      journal: "Wound Repair and Regeneration",
      year: "2014",
      volume: "22",
      pages: "A31",
      impactFactor: "3.4",
      type: "Research Article"
    },
  ],
  "2012":[
    {
      id: 160,
      authors: "Biman B Mandal, Ariela Grinberg, Eun Seok Gil, Bruce Panilaitis, David L. Kaplan",
      title: "High strength silk protein scaffolds for bone repair",
      journal: "PNAS",
      year: "2012",
      volume: "109",
      pages: "7699-704",
      impactFactor: "9.1",
      doi: "https://doi.org/10.1073/pnas.1119474109",
      type: "Research Article"
    },
    {
      id: 161,
      authors: "Lindsay S. Wray, Jelena Rnjak-Kovacina, Biman B. Mandal, Daniel Schmidt, Eun Seok Gil, David L. Kaplan",
      title: "A silk-based scaffold platform with tunable architecture for engineering critically-sized tissue constructs",
      journal: "Biomaterials",
      year: "2012",
      volume: "33",
      pages: "9214-24",
      impactFactor: "12.9",
      doi: "https://doi.org/10.1016/j.biomaterials.2012.09.017",
      type: "Research Article"
    },
    {
      id: 162,
      authors: "Lee W. Tien, Eun Seok Gil, Sang-Hyug Park, Biman B. Mandal, David L. Kaplan",
      title: "Patterned silk fibroin film scaffolds for aligned lamellar bone tissue engineering",
      journal: "Macromolecular Bioscience",
      year: "2012",
      volume: "12",
      pages: "1671-1679",
      impactFactor: "4.1",
      doi: "https://doi.org/10.1002/mabi.201200193",
      type: "Research Article"
    },
    {
      id: 163,
      authors: "Sang-Hyug Park, Eun Seok Gil, Biman B. Mandal, Hong Sik Cho, Jonathan A. Kluge, Byoung-Hyun Min, David L. Kaplan",
      title: "Annulus fibrosus tissue engineering using lamellar silk scaffold",
      journal: "Journal of Tissue Engineering and Regenerative Medicine",
      year: "2012",
      volume: "suppl 3",
      pages: "s24-33",
      impactFactor: "2.6",
      doi: "https://doi.org/0.1002/term.541",
      type: "Research Article"
    },
    {
      id: 164,
      authors: "Subhas C. Kundu, Banani Kundu, Sarmistha Talukdar, Subia Bano, Sunita Nayak, Joydip Kundu, Biman B. Mandal, Nandana Bhardwaj, Mahendran Botlagunta, Birja C. Dash, Chitrangda Acharya, Ananta K. Ghosh",
      title: "Non-mulberry silk biopolymers for tissue engineering, regenerative medicine and biotechnological uses",
      journal: "Biopolymers",
      year: "2012",
      volume: "97",
      pages: "455-467",
      impactFactor: "3.2",
      doi: "https://doi.org/10.1002/bip.22024",
      type: "Review"
    },
    {
      id: 186,
      authors: "Sang-Hyug Park, Eun Seok Gil, Hong Sik Cho, Biman B. Mandal, Lee W. Tien, Byoung-Hyun Min, David L. Kaplan",
      title: "Intervertebral disc tissue engineering using biphasic silk composite scaffolds",
      journal: "Tissue Engineering Part A",
      year: "2012",
      pages: "447-458",
      impactFactor: "2.9",
      doi: "https://doi.org/10.1089/ten.TEA.2011.0195",
      type: "Research Article"
    },
    {
      id: 165,
      authors: "Jelena Rnjak-Kovacina, Lindsay S Wray, Biman B Mandal, Eun Seok Gil, Anthony S. Weiss, David L. Kaplan",
      title: "Versatile biomaterial scaffold platform for critically-sized tissue constructs",
      journal: "Journal of Tissue Engineering and Regenerative Medicine",
      year: "2012",
      volume: "6",
      pages: "387",
      impactFactor: "2.6",
      type: "Research Article"
    }
  ],
  "2011": [
    {
      id: 166,
      authors: "Biman B. Mandal, Sang-Hyug Park, Eun Seok Gil, David L. Kaplan",
      title: "Stem cell based meniscus tissue engineering",
      journal: "Tissue Engineering Part A",
      year: "2011",
      volume: "17",
      pages: "2749-2761",
      impactFactor: "2.9",
      doi: "https://doi.org/10.1089/ten.TEA.2011.0031",
      type: "Research Article"
    },
    {
      id: 167,
      authors: "Sang-Hyug Park, Hong Sik Cho, Eun Seok Gil, Biman B. Mandal, Byoung-Hyun Min, David L. Kaplan",
      title: "Silk-fibrin/hyaluronic acid composite gels for nucleus pulposus (NP) tissue regeneration",
      journal: "Tissue Engineering Part A",
      year: "2011",
      volume: "17",
      pages: "2999-3009",
      impactFactor: "2.9",
      doi: "https://doi.org/10.1089/ten.TEA.2010.0747",
      type: "Research Article"
    },
    {
      id: 168,
      authors: "Biman B. Mandal, Borna Ghosh, Subhas C. Kundu",
      title: "Non-mulberry silk sericin/poly (vinyl alcohol) hydrogel matrices for potential biotechnological applications",
      journal: "International Journal of Biological Macromolecules",
      year: "2011",
      volume: "49",
      pages: "125-33",
      impactFactor: "8.5",
      doi: "https://doi.org/10.1016/j.ijbiomac.2011.03.015",
      type: "Research Article"
    },
    {
      id: 169,
      authors: "Biman B. Mandal, Sang-Hyug Park, Eun Seok Gil, David L. Kaplan",
      title: "Multilayered silk scaffolds for meniscus tissue engineering",
      journal: "Biomaterials",
      year: "2011",
      volume: "32",
      pages: "639-51",
      impactFactor: "12.9",
      doi: "https://doi.org/10.1016/j.biomaterials.2010.08.115",
      type: "Research Article"
    }
  ],
  "2010": [
    {
      id: 170,
      authors: "Eun Seok Gil, Biman B. Mandal, Sang-Hyug Park, Jeff Marchant, Fiorenzo Omenetto, David L. Kaplan",
      title: "Helicoidal Multi-Lamellar Features of RGD-functionalized Silk Biomaterials for Corneal Tissue Engineering",
      journal: "Biomaterials",
      year: "2010",
      volume: "31",
      pages: "8953-63",
      impactFactor: "12.9",
      doi: "https://doi.org/10.1016/j.biomaterials.2010.08.017",
      type: "Research Article"
    },
    {
      id: 171,
      authors: "Biman B. Mandal, Soumen Das, Koel Choudhury, Subhas C. Kundu",
      title: "Implications of silk film RGD availability and surface roughness on cytoskeletal organization and proliferation of primary rat bone marrow cells",
      journal: "Tissue Engineering Part A",
      year: "2010",
      volume: "16",
      pages: "2391-403",
      impactFactor: "2.9",
      doi: "https://doi.org/10.1089/ten.TEA.2009.0206",
      type: "Research Article"
    },
    {
      id: 172,
      authors: "Biman B. Mandal, Subhas C. Kundu",
      title: "Biospinning by silkworms: Silk fiber matrices for tissue engineering applications",
      journal: "Acta Biomaterialia",
      year: "2010",
      volume: "6",
      pages: "360-71",
      impactFactor: "9.6",
      doi: "https://doi.org/10.1016/j.actbio.2009.08.035",
      type: "Review"
    },
  ],
  "2009": [
    {
      id: 173,
      authors: "Biman B. Mandal, Subhas C. Kundu",
      title: "Calcium alginate bead embedded in silk fibroin as 3D dual release scaffolds",
      journal: "Biomaterials",
      year: "2009",
      volume: "30",
      pages: "5170-5177",
      impactFactor: "12.9",
      doi: "https://doi.org/10.1016/j.biomaterials.2009.05.072",
      type: "Research Article"
    },
    {
      id: 174,
      authors: "Biman B. Mandal, Subhas C. Kundu",
      title: "Osteogenic and adipogenic differentiation of rat bone marrow cells on mulberry and non-mulberry silk gland fibroin 3D scaffolds",
      journal: "Biomaterials",
      year: "2009",
      volume: "30",
      pages: "5019-5030",
      impactFactor: "12.9",
      doi: "https://doi.org/10.1016/j.biomaterials.2009.05.064",
      type: "Research Article"
    },
    {
      id: 175,
      authors: "Biman B. Mandal, Sonia Kapoor, Subhas C. Kundu",
      title: "Silk fibroin/polyacrylamide semi-interpenetrating network hydrogels for controlled drug release",
      journal: "Biomaterials",
      year: "2009",
      volume: "30",
      pages: "2826-2836",
      impactFactor: "12.9",
      doi: "https://doi.org/10.1016/j.biomaterials.2009.01.040",
      type: "Research Article"
    },
    {
      id: 176,
      authors: "Biman B. Mandal, Subhas C. Kundu",
      title: "Cell proliferation and migration in 3D silk fibroin scaffolds",
      journal: "Biomaterials",
      year: "2009",
      volume: "30",
      pages: "2956-2965",
      impactFactor: "14",
      doi: "https://doi.org/10.1016/j.biomaterials.2009.02.006",
      type: "Research Article"
    },
    {
      id: 177,
      authors: "Biman B. Mandal, Subhas C. Kundu",
      title: "Non-mulberry silk gland fibroin 3D scaffold for enhanced differentiation of human mesenchymal stem cells into osteocytes",
      journal: "Acta Biomaterialia",
      year: "2009",
      volume: "5",
      pages: "2579-2590",
      impactFactor: "9.6",
      doi: "https://doi.org/10.1016/j.actbio.2009.02.033",
      type: "Research Article"
    },
    {
      id: 178,
      authors: "Biman B. Mandal, Anjana S. Priya, Subhas C. Kundu",
      title: "Novel silk sericin-gelatin 3D scaffolds and 2D films: Fabrication and characterization for potential tissue engineering applications",
      journal: "Acta Biomaterialia",
      year: "2009",
      volume: "5",
      pages: "3007-3020",
      impactFactor: "9.6",
      doi: "https://doi.org/10.1016/j.actbio.2009.03.026",
      type: "Research Article"
    },
    {
      id: 179,
      authors: "Biman B. Mandal, Subhas C. Kundu",
      title: "Self assembled silk sericin/poloxamer nanoparticles as nanocarriers of hydrophobic and hydrophilic drugs for targeted delivery applications",
      journal: "Nanotechnology",
      year: "2009",
      volume: "20",
      pages: "355101",
      impactFactor: "2.8",
      doi: "https://doi.org/10.1088/0957-4484/20/35/355101",
      type: "Research Article"
    },
    {
      id: 180,
      authors: "Biman B. Mandal, Jasdeep K. Mann, Subhas C. Kundu",
      title: "Silk fibroin/gelatin multilayered films as a model system for controlled drug release",
      journal: "European Journal of Pharmaceutical Sciences",
      year: "2009",
      volume: "37",
      pages: "160-171",
      impactFactor: "4.7",
      doi: "https://doi.org/10.1016/j.ejps.2009.02.005",
      type: "Research Article"
    },
    {
      id: 181,
      authors: "Biman B. Mandal, Tamal Das, Subhas C. Kundu",
      title: "Non-bioengineered silk gland fibroin micromolded matrices to study cell-surface interactions",
      journal: "Biomedical Microdevices",
      year: "2009",
      volume: "11",
      pages: "467-476",
      impactFactor: "3.3",
      doi: "https://doi.org/10.1007/s10544-008-9252-x",
      type: "Research Article"
    },
    {
      id: 182,
      authors: "Biraja C. Dash, Biman B. Mandal, Subhas C. Kundu",
      title: "Silk gland sericin protein membranes: fabrication and characterization for potential biotechnological applications",
      journal: "Journal of Biotechnology",
      year: "2009",
      volume: "144",
      pages: "321-329",
      impactFactor: "3.9",
      doi: "https://doi.org/10.1016/j.jbiotec.2009.09.019",
      type: "Research Article"
    }
  ],
  "2008": [
    {
      id: 183,
      authors: "Biman B. Mandal, Subhas C. Kundu",
      title: "A novel method for dissolution and stabilization of non-mulberry silk gland protein fibroin using anionic surfactant sodium dodecyl sulfate",
      journal: "Biotechnology and Bioengineering",
      year: "2008",
      volume: "99",
      pages: "1482-1489",
      impactFactor: "3.6",
      doi: "https://doi.org/10.1002/bit.21699",
      type: "Research Article"
    },
    {
      id: 184,
      authors: "Biman B. Mandal, Subhas C. Kundu",
      title: "Non-bioengineered silk gland fibroin protein: Characterization and evaluation of matrices for potential tissue engineering applications",
      journal: "Biotechnology and Bioengineering",
      year: "2008",
      volume: "100",
      pages: "1237-1250",
      impactFactor: "3.6",
      doi: "https://doi.org/10.1002/bit.21835",
      type: "Research Article"
    },
    {
      id: 185,
      authors: "Biman B. Mandal and Subhas C. Kundu",
      title: "Non-bioengineered silk fibroin protein 3D scaffolds for potential biotechnological and tissue engineering applications",
      journal: "Macromolecular Bioscience",
      year: "2008",
      volume: "8",
      pages: "807-818",
      impactFactor: "4.1",
      doi: "https://doi.org/10.1002/mabi.200800113",
      type: "Research Article"
    },

  ]
};

const Publication = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedYear, setSelectedYear] = useState('All');
  const [expandedYears, setExpandedYears] = useState({});
  const [selectedPublication, setSelectedPublication] = useState(null);

  useEffect(() => {
    const years = Object.keys(publicationsData);
    const initialExpanded = {};
    years.forEach(year => {
      initialExpanded[year] = true;
    });
    setExpandedYears(initialExpanded);
  }, []);

  const allPublications = Object.values(publicationsData).flat();
  const years = ['All', ...Object.keys(publicationsData).sort((a,b) => b - a)];

  // Calculate enhanced statistics
  const stats = {
    total: allPublications.length,
    totalCitations: allPublications.reduce((sum, p) => sum + (p.citations || 0), 0),
    cumulativeIF: allPublications
      .filter(p => p.impactFactor && p.impactFactor !== 'Preprint')
      .reduce((sum, p) => sum + parseFloat(p.impactFactor), 0)
      .toFixed(1),
  };

  const getFilteredPublications = () => {
    let filtered = selectedYear === 'All' ? publicationsData : {[selectedYear]: publicationsData[selectedYear] || []};
    if(searchTerm){
      const searchFiltered = {};
      Object.keys(filtered).forEach(year => {
        const pubs = filtered[year].filter(pub =>
          pub.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
          pub.authors.toLowerCase().includes(searchTerm.toLowerCase()) ||
          pub.journal.toLowerCase().includes(searchTerm.toLowerCase())
        );
        if(pubs.length) searchFiltered[year] = pubs;
      });
      return searchFiltered;
    }
    return filtered;
  };

  const toggleYear = (year) => {
    setExpandedYears(prev => ({...prev, [year]: !prev[year]}));
  };

  const openPublicationModal = (pub) => {
    setSelectedPublication(pub);
    document.body.style.overflow = 'hidden';
  };

  const closePublicationModal = () => {
    setSelectedPublication(null);
    document.body.style.overflow = 'auto';
  };

  const getPublicationTypeColor = (type) => {
    switch(type) {
      case "Research Article": return "#254a7b";
      case "Review": return "#4e78b2";
      case "Preprint": return "#6b8fc7";
      default: return "#8ba5d0";
    }
  };

  const filteredPublications = getFilteredPublications();

  return (
    <div className="publication-page">
      <div className="publication-container">
        <section className="publication-header">
          <h1 className="publication-title">Publications</h1>
        </section>

        <section className="publication-stats-bar">
          <div className="stat-item">
            <span className="stat-value">200+</span>
            <span className="stat-label">Total Publications</span>
          </div>
          <div className="stat-item">
            <span className="stat-value">16400+</span>
            <span className="stat-label">Total Citations</span>
          </div>
          <div className="stat-item">
            <span className="stat-value">1300+</span>
            <span className="stat-label">Cumulative IF</span>
          </div>
          <div className="stat-item">
            <span className="stat-value">71</span>
            <span className="stat-label">H-Index</span>
          </div>
        </section>

        <section className="publication-controls">
          <div className="filter-tabs">
            {years.map(year => (
              <button 
                key={year} 
                className={`filter-tab ${selectedYear === year ? 'active' : ''}`} 
                onClick={() => setSelectedYear(year)}
              >
                {year}
              </button>
            ))}
          </div>

          <div className="controls-row">
            <div className="search-bar">
              <input 
                type="text" 
                placeholder="Search by title, authors, or journal..." 
                className="search-input" 
                value={searchTerm} 
                onChange={e => setSearchTerm(e.target.value)} 
              />
              <svg className="search-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                <circle cx="11" cy="11" r="8" />
                <path d="m21 21-4.35-4.35"/>
              </svg>
            </div>
          </div>
          
          <div className="impact-factor-disclaimer">
            *Impact factors subject to change. Last updated July 2025
          </div>
        </section>

        <section className="publications-list">
          {Object.keys(filteredPublications).sort((a,b) => b-a).map(year => (
            <div key={year} className="year-section">
              <div className="year-header" onClick={() => toggleYear(year)}>
                <h2 className="year-title">{year}</h2>
                <svg className={`year-toggle ${expandedYears[year] ? 'expanded' : ''}`} viewBox="0 0 24 24" fill="none" stroke="currentColor"><path d="M19 9l-7 7-7-7" /></svg>
              </div>
              {expandedYears[year] && (
                <div className="year-publications">
                  {filteredPublications[year].map((pub,index) => (
                    <div key={pub.id} className="publication-card" onClick={() => openPublicationModal(pub)}>
                      <div className="publication-content">
                        <h3 className="publication-paper-title">{pub.title}</h3>
                        <p className="publication-authors">{pub.authors}</p>
                        <div className="publication-meta">
                          <span className="publication-journal">{pub.journal}</span>
                          <span className="publication-type" style={{backgroundColor: getPublicationTypeColor(pub.type)}}>{pub.type}</span>
                          {pub.impactFactor && <span className="publication-if">IF: {pub.impactFactor}</span>}
                          {pub.citations > 0 && (
                            <span className="publication-citations">
                              <svg viewBox="0 0 24 24" className="citation-icon">
                                <path d="M7 7h10M7 12h10M7 17h10" stroke="currentColor"/>
                              </svg>
                              {pub.citations} citations
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="publication-actions">
                        <button className="view-details-btn">View Details</button>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </section>

        {Object.keys(filteredPublications).length === 0 && (
          <div className="no-results">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="no-results-icon"><circle cx="11" cy="11" r="8"></circle><path d="m21 21-4.35-4.35"></path></svg>
            <p>No publications found matching your criteria.</p>
            <button className="reset-btn" onClick={() => {setSearchTerm(''); setSelectedYear('All')}}>Reset Filters</button>
          </div>
        )}

        {selectedPublication && (
          <div className="publication-modal" onClick={closePublicationModal}>
            <div className="modal-content" onClick={e => e.stopPropagation()}>
              <button className="modal-close" onClick={closePublicationModal}>
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M18 6L6 18M6 6l12 12"/></svg>
              </button>

              <div className="modal-header">
                <span className="modal-type-badge" style={{backgroundColor: getPublicationTypeColor(selectedPublication.type)}}>{selectedPublication.type}</span>
                <h2 className="modal-title">{selectedPublication.title}</h2>
              </div>

              <div className="modal-body">
                <div className="modal-section">
                  <h4>Authors</h4>
                  <p className="authors-list">{selectedPublication.authors}</p>
                </div>
                <div className="modal-section">
                  <h4>Publication Details</h4>
                  <div className="details-grid">
                    <div className="detail-item"><span className="detail-label">Journal:</span><span className="detail-value">{selectedPublication.journal}</span></div>
                    <div className="detail-item"><span className="detail-label">Year:</span><span className="detail-value">{selectedPublication.year}</span></div>
                    {selectedPublication.volume && <div className="detail-item"><span className="detail-label">Volume:</span><span className="detail-value">{selectedPublication.volume}</span></div>}
                    {selectedPublication.issue && <div className="detail-item"><span className="detail-label">Issue:</span><span className="detail-value">{selectedPublication.issue}</span></div>}
                    {selectedPublication.pages && <div className="detail-item"><span className="detail-label">Pages:</span><span className="detail-value">{selectedPublication.pages}</span></div>}
                    {selectedPublication.impactFactor && <div className="detail-item"><span className="detail-label">Impact Factor:</span><span className="detail-value highlight">{selectedPublication.impactFactor}</span></div>}
                  </div>
                </div>
                <div className="modal-footer">
                  {selectedPublication.doi && (
                    <a href={selectedPublication.doi} target="_blank" rel="noopener noreferrer" className="doi-link">
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor"><path d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"/></svg>
                      View Publication
                    </a>
                  )}
                  <button className="cite-btn" onClick={()=>{
                    const citation = `${selectedPublication.authors}. ${selectedPublication.title}. ${selectedPublication.journal} (${selectedPublication.year}). DOI: ${selectedPublication.doi}`;
                    navigator.clipboard.writeText(citation);
                    alert('Citation copied to clipboard!');
                  }}>
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor"><path d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"/></svg>
                    Copy Citation
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

      </div>
    </div>
  )
};

export default Publication;
